import React, {Component} from 'react';
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';

import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {Decimal} from 'decimal.js';
import NumberFormat from 'react-number-format';
import {UncontrolledTooltip} from 'reactstrap';
import InvoiceLineModal from "./InvoiceLineModal";
import LineChargeModal from "./LineChargeModal";
import {deepCopyObject, getStocks, showAxiosError} from "../../../helper/helper";
import {
    isValidCezaeviData,
    isValidMedikalIcmal,
    isValidMedulaData,
    isValidMedulaOptikData
} from "../../../common/componentValidation";
import {validateField} from "../../../common/validation";
import StockModal from "../../stock/StockModal";
import {filterOptions} from "../../../helper/invoiceHelper";
import XLSX from 'xlsx';
import Alert from "react-s-alert";
import {EntegratorIdentifiers, InvoiceLineEnum} from "../../../helper/enums";
import moment from "moment";
import MedulaModal from "./MedulaModal";
import {EntegratorConf, VirtualHost} from "../../../constants";
import {request} from "../../../helper/APIUtils";
import CezaeviModal from "./CezaeviModal";
import KonaklamaModal from "./KonaklamaModal";
import {showKonaklamaVergisiButton} from "../../../helper/permission";
import {value} from "lodash/seq";
import InvoiceLineItsUtsModal from "./InvoiceLineItsUtsModal";

class InvoiceLines extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trdDocInvoiceLines: [],
            addedLineCharges: [],
            addedLineKdvExemption: [],
            addedLineOtvExemption: [],
            invoiceLineModal: false,
            lineChargeModal: false,
            stockModal: false,
            index: 0,
            hasError: false,
            excelDropdownOpen: false,
            fromTotalToUnit: false,
            isMobile : window.innerWidth > 991 ? false : true,
            showMedulaImport: ["eczacikart", "farmakom", "smart", "kolaysoft", "hizli", "togb", "vega", "medikal", "isitmemerkezi", "testud", "mikrokom", "neoyazilim","mbtfatura"].includes(VirtualHost.conf.resourcePrefix),
            isKonaklama : false
        };
        this.addInvoiceLine = this.addInvoiceLine.bind(this);
        this.editLineCharges = this.editLineCharges.bind(this);
        this.setLineCharges = this.setLineCharges.bind(this);
        this.removeInvoiceLine = this.removeInvoiceLine.bind(this);
        this.editInvoiceLine = this.editInvoiceLine.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onStockChange = this.onStockChange.bind(this);
        this.setStocks = this.setStocks.bind(this);
        this.getChargeWithCode = this.getChargeWithCode.bind(this);
        this.changeLineChargeValue = this.changeLineChargeValue.bind(this);
        this.validateField = this.validateField.bind(this);
        this.setDeliveryDetail = this.setDeliveryDetail.bind(this);
        this.setInvoiceLine = this.setInvoiceLine.bind(this);
        this.handleUploadExcel = this.handleUploadExcel.bind(this);
        this.bulkFileSelected = this.bulkFileSelected.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.switchRoundKDV = this.switchRoundKDV.bind(this);
        this.applyMedula = this.applyMedula.bind(this);
        this.applyCezaevi = this.applyCezaevi.bind(this);
        this.applyMedulaOptik = this.applyMedulaOptik.bind(this);
        this.applyMedikalIcmal = this.applyMedikalIcmal.bind(this);
        this.getExternalCustomerGocIdaresi = this.getExternalCustomerGocIdaresi.bind(this);
        this.switchFromTotalToUnit = this.switchFromTotalToUnit.bind(this);
        this.exportStockToExcelUnits = this.exportStockToExcelUnits.bind(this);
        this.exportPackageCodesToExcelUnits = this.exportPackageCodesToExcelUnits.bind(this);
        this.exportDeliveryTermsToExcelUnits = this.exportDeliveryTermsToExcelUnits.bind(this);
        this.exportTransportCodesToExcelUnits = this.exportTransportCodesToExcelUnits.bind(this);
        this.exportCountryCodesToExcel= this.exportCountryCodesToExcel.bind(this);
        this.applyMedikal=this.applyMedikal.bind(this);
        this.inputFile = React.createRef();
        this.onInputChange = this.onInputChange.bind(this);
        this.onInputKeyDown = this.onInputKeyDown.bind(this);
        this.setKonaklama = this.setKonaklama.bind(this);
        this.onChangeTevkifatIade = this.onChangeTevkifatIade.bind(this);
        this.addItsUtsInformationLine = this.addItsUtsInformationLine.bind(this);
        this.setInvoiceLineItsUts = this.setInvoiceLineItsUts.bind(this);
        this.addItsUtsLine = this.addItsUtsLine.bind(this);
        this.closeInvoiceLineItsUtsModal = this.closeInvoiceLineItsUtsModal.bind(this);
    }

    componentWillMount() {
        let trdDocInvoiceLines = deepCopyObject(this.props.trdDocInvoiceLines);
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            let trdDocInvoiceLineCharges = trdDocInvoiceLines[i].trdDocInvoiceLineCharges;
            trdDocInvoiceLineCharges.sort((charge1, charge2) => charge1.taxCode.priority - charge2.taxCode.priority);
        }

        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            trdDocInvoiceLines[i] = InvoiceLines.calculate(trdDocInvoiceLines[i], ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
        }

        this.setState({
            trdDocInvoiceLines: trdDocInvoiceLines,
            unitCodes: this.props.unitCodes,
            withholdingTypes: this.props.withholdingTypes,
            countries: this.props.countries,
            packageTypeCodes: this.props.packageTypeCodes,
            deliveryTermsCodes: this.props.deliveryTermsCodes,
            transportMeansTypeCodes: this.props.transportMeansTypeCodes,
            transportModeCodes: this.props.transportModeCodes
        },()=>this.props.listener(trdDocInvoiceLines));
    }

    componentDidCatch(error, info) {
        console.log("1-------------------");
        console.log(error);
        console.log("2-------------------");
        console.log(info);
        console.log("3-------------------");
        this.setState({hasError: true});
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.trdDocInvoiceLines !== nextProps.trdDocInvoiceLines) {
            this.setState({trdDocInvoiceLines: nextProps.trdDocInvoiceLines});
        }

        if (nextProps.manual) {
            this.setState({trdDocInvoiceLines: nextProps.trdDocInvoiceLines, error: {}});
            this.props.isManual(false);
            this.props.errorListener({});
        }

        if ((nextProps.invoiceTypeCode === "SGK" && this.props.invoiceTypeCode !== "SGK") ||
            (nextProps.invoiceTypeCode !== "SGK" && this.props.invoiceTypeCode === "SGK")) {
            let trdDocInvoiceLines = deepCopyObject(nextProps.trdDocInvoiceLines);
            for (let i = 0; i < trdDocInvoiceLines.length; i++) {
                trdDocInvoiceLines[i] = InvoiceLines.calculate(trdDocInvoiceLines[i], ((nextProps.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
            }
            this.setState({trdDocInvoiceLines: trdDocInvoiceLines});
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        if (id.includes("kunyeNo"))
            rule = "kunyeNo";
        let result = validateField(rule, boundary, e.target.value);
        let error = this.props.error;
        error = Object.assign(error, {[id]: result});
        this.props.errorListener(error);
    }

    validateClass(id) {
        let error = this.props.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.props.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    handleUploadExcel(e) {
        let self = this;
        let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        if (files && files[0]) {
            let type = files[0].type;
            let size = files[0].size;
            let name = files[0].name;
            let allowedExtensions = /(\.xls|\.xlsx|\.csv)$/i;
            if (!allowedExtensions.exec(name)) {
                Alert.error("Dosya formatı uygun değil.(.xls,.xlsx,.csv)", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 4000,
                    html: true
                });
                return;
            }
            let fileReader = new FileReader();
            fileReader.readAsArrayBuffer(files[0]);
            fileReader.onload = () => {
                self.bulkFileSelected(fileReader.result, self);
            };

            e.target.value = null;
        } else {
            Alert.error("Dosya bulunamadı.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000,
                html: true
            });
            e.target.value = null;
            return;
        }
    }

    bulkFileSelected(fileContent, self) {
        self.setState({processingExcel: true});
        let workbook = XLSX.read(fileContent, {type: "array"});
        let sheet = workbook.Sheets[workbook.SheetNames[0]];
        let range = XLSX.utils.decode_range(sheet["!ref"]);
        let trdDocInvoiceLines = [];
        for (let row = range.s.r; row <= range.e.r; row++) {
            if (row > 0) {
                let rowData = {};
                for (let col = range.s.c; col <= range.e.c; col++) {
                    let cell = sheet[XLSX.utils.encode_cell({r: row, c: col})];
                    if (cell) {
                        rowData[InvoiceLineEnum[col]] = cell.v;
                    }
                }

                //check rowData is not equal {}
                if (!(Object.keys(rowData).length === 0 && rowData.constructor === Object)) {
                    let result = self.validateRowData(rowData, row);
                    if (result.valid) {
                        let invoiceLine = self.rowToInvoiceLine(rowData);
                        trdDocInvoiceLines.push(invoiceLine);
                    } else {
                        Alert.error(result.message, {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 4000,
                            html: true
                        });
                        self.setState({processingExcel: false});
                        return;
                    }
                }
            }
        }

        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            trdDocInvoiceLines[i] = InvoiceLines.calculate(trdDocInvoiceLines[i], ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
        }
        if (trdDocInvoiceLines.length > 0) {
            self.setState({trdDocInvoiceLines});
            self.props.listener(trdDocInvoiceLines);
        } else {

        }
        self.setState({processingExcel: false});
    }

    async exportStockToExcelUnits() {
        let data = [];
        data.push({
            unit: "STOK BİRİMLERİ",
            unitCode: "STOK BİRİM KODU"
        });
        let params = {
            url: "/stock/getUnitCodes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let unitCodes = response.data;
                for (let i = 0; i < unitCodes.length; i++) {
                    let longCode = unitCodes[i].longCode;
                    let shortCode = unitCodes[i].shortCode;
                    data.push({
                        unit: longCode,
                        unitCode: shortCode
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    async exportPackageCodesToExcelUnits() {
        let data = [];
        data.push({
            package: "PAKET/KUTU TÜRÜ",
            packageCode: "PAKET/KUTU KODU"
        });
        let params = {
            url: "/packageTypeCode/getCodes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let packageCodes = response.data;
                for (let i = 0; i < packageCodes.length; i++) {
                    let longName = packageCodes[i].longName;
                    let shortName = packageCodes[i].shortName;
                    data.push({
                        package: longName,
                        packageCode: shortName
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    async exportDeliveryTermsToExcelUnits() {
        let data = [];
        data.push({
            deliveryTr: "TESLİMAT ŞARTI TR",
            deliveryEn: "TESLİMAT ŞARTI EN",
            deliveryCode: "TESLİMAT KODU"
        });
        let params = {
            url: "/deliveryTerms/getCodes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let deliveryCodes = response.data;
                for (let i = 0; i < deliveryCodes.length; i++) {
                    let longNameTr = deliveryCodes[i].longNameTr;
                    let longNameEn = deliveryCodes[i].longNameEn;
                    let shortName = deliveryCodes[i].shortName;
                    data.push({
                        deliveryTr: longNameTr,
                        deliveryEn: longNameEn,
                        deliveryCode: shortName
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    async exportTransportCodesToExcelUnits() {
        let data = [];
        data.push({
            transport: "GÖNDERİM ŞEKLİ",
            transportCode: "GÖNDERİM KODU"
        });
        let params = {
            url: "/transportModeCode/getCodes",
            method: "get"
        };
        await request(params)
            .then(function (response) {
                let transportCodes = response.data;
                for (let i = 0; i < transportCodes.length; i++) {
                    let longName = transportCodes[i].longName;
                    let shortName = transportCodes[i].shortName;
                    data.push({
                        transport: longName,
                        transportCode: shortName
                    });
                }
            }).catch(function (error) {
                showAxiosError(error);
            });

        return data;
    }

    async exportCountryCodesToExcel() {
        let self=this;
        let data = [];
        data.push({
            country: "ÜLKE ADI",
        });
        let countryCodes = this.props.countries;
        for (let i = 0; i < countryCodes.length; i++) {
            let longName = countryCodes[i].longNameTr;
            data.push({
                country: longName,
            });
        }
        return data;
    }

    async exportToExcel(e) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let unitCodes = await this.exportStockToExcelUnits();
        let packageCodes, deliveryCodes, transportCodes, countryCodes;
        if (this.props.profileId === "IHRACAT") {
            packageCodes = await this.exportPackageCodesToExcelUnits();
            deliveryCodes = await this.exportDeliveryTermsToExcelUnits();
            transportCodes = await this.exportTransportCodesToExcelUnits();
            countryCodes = await this.exportCountryCodesToExcel();
        }
        let data = [];
        data.push({
            itemName: "Ürün Adı",
            quantity: "Miktar",
            unit: "Birim",
            unitPrice: "Birim Fiyat",
            allowancePercentage: "İskonto %",
            allowanceAmount: "İskonto Tutar",
            kdvPercentage: "KDV %",
            kdvAmount: "KDV Tutar",
            lineExplanation: "Satır Açıklaması"
        })
        if (this.props.profileId === "IHRACAT") {
            data[0]["gtip"] = "GTİP No";
            data[0]["actualPackageId"] = "Paket/Kutu Numarası";
            data[0]["packageType"] = "Paket/Kutu Türü Kodu";
            data[0]["actualPackageQuantity"] = "Paket/Kutu Adedi";
            data[0]["packageBrand"] = "Paket/Kutu Markası";
            data[0]["deliveryTerms"] = "Teslimat Şartı Kodu";
            data[0]["shipmentId"] = "Kargo No";
            data[0]["transportModeCode"] = "Gönderim Şekli Kodu";
            data[0]["country"] = "Ülke";
            data[0]["city"] = "İl";
            data[0]["citySubdivion"] = "İlçe";
            data[0]["streetName"] = "Cadde";
            data[0]["postalZone"] = "Posta Kodu";
            data[0]["buildingName"] = "Bina Adı";
            data[0]["buildingNumber"] = "Bina No";
        }
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            let line = trdDocInvoiceLines[i];
            let iskonto = line.trdDocInvoiceLineCharges.find(function (charge) {
                return charge.taxCode.code === "0000";
            });

            let kdv = line.trdDocInvoiceLineCharges.find(function (charge) {
                return charge.taxCode.code === "0015";
            });

            let row = {
                itemName: (line["itemName"] !== "" && line["itemName"] !== null ? line["itemName"] : "Boş Olamaz"),
                quantity: line["quantity"],
                unit: line["unit"],
                unitPrice: line["unitPrice"],
                allowancePercentage: (iskonto ? iskonto.percentage : 0.00),
                allowanceAmount: (iskonto ? iskonto.amount : 0.00),
                kdvPercentage: (kdv ? kdv.percentage : 0.00),
                kdvAmount: (kdv ? kdv.amount : 0.00),
                lineExplanation:line["lineExplanation"],
               };

            if (this.props.profileId === "IHRACAT") {
                row["gtip"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["gtip"] ? line.trdDocInvoiceLineDeliveryDetail["gtip"] : "");
                row["actualPackageId"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["actualPackageId"] ? line.trdDocInvoiceLineDeliveryDetail["actualPackageId"] : "");
                row["packageType"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["actualPackagePTC"] ? line.trdDocInvoiceLineDeliveryDetail["actualPackagePTC"] : "1A");
                row["actualPackageQuantity"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["actualPackageQuantity"] ? line.trdDocInvoiceLineDeliveryDetail["actualPackageQuantity"] : "");
                row["packageBrand"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["packageBrand"] ? line.trdDocInvoiceLineDeliveryDetail["packageBrand"] : "");
                row["deliveryTerms"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["deliveryTerms"] ? line.trdDocInvoiceLineDeliveryDetail["deliveryTerms"] : "DAF");
                row["shipmentId"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["shipmentId"] ? line.trdDocInvoiceLineDeliveryDetail["shipmentId"] : "");
                row["transportModeCode"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["transportModeCode"] ? line.trdDocInvoiceLineDeliveryDetail["transportModeCode"] : 1);
                row["country"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["country"] ? line.trdDocInvoiceLineDeliveryDetail["country"] : "");
                row["city"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["city"] ? line.trdDocInvoiceLineDeliveryDetail["city"] : "");
                row["citySubdivion"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["citySubdivion"] ? line.trdDocInvoiceLineDeliveryDetail["citySubdivion"] : "");
                row["streetName"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["streetName"] ? line.trdDocInvoiceLineDeliveryDetail["streetName"] : "");
                row["postalZone"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["postalZone"] ? line.trdDocInvoiceLineDeliveryDetail["postalZone"] : "");
                row["buildingName"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["buildingName"] ? line.trdDocInvoiceLineDeliveryDetail["buildingName"] : "");
                row["buildingNumber"] = (line.trdDocInvoiceLineDeliveryDetail && line.trdDocInvoiceLineDeliveryDetail["buildingNumber"] ? line.trdDocInvoiceLineDeliveryDetail["buildingNumber"] : "");
            }

            data.push(row);
        }

        /* make the worksheet */
        let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});
        let ws2 = XLSX.utils.json_to_sheet(unitCodes, {skipHeader: true});
        let ws3,ws4,ws5,ws6;
        if (this.props.profileId === "IHRACAT") {
            ws3 = XLSX.utils.json_to_sheet(packageCodes, {skipHeader: true});
            ws4 = XLSX.utils.json_to_sheet(deliveryCodes, {skipHeader: true});
            ws5 = XLSX.utils.json_to_sheet(transportCodes, {skipHeader: true});
            ws6 = XLSX.utils.json_to_sheet(countryCodes, {skipHeader: true});
        }
        /* add to workbook */
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Şablon");
        XLSX.utils.book_append_sheet(wb, ws2, "Stok Birimleri");
        if (this.props.profileId === "IHRACAT") {
            XLSX.utils.book_append_sheet(wb, ws3, "Paket_Kutu Türleri");
            XLSX.utils.book_append_sheet(wb, ws4, "Teslimat Şartları");
            XLSX.utils.book_append_sheet(wb, ws5, "Gönderim Şekilleri");
            XLSX.utils.book_append_sheet(wb, ws6, "Ülke Adları");
        }

        /* generate an XLSX file */
        XLSX.writeFile(wb, "urun_hizmetler_" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx");
    }

    validateRowData(rowData, row) {
        let message = "";
        let valid = true;
        if (rowData["itemName"] === undefined || rowData["itemName"] === '') {
            message = message + `${row }. Satırdaki Ürün Adı alanı formatı uygun değil.</br>`;
            valid = false;
        } if (typeof rowData["quantity"] !== 'number') {
            message = message + `${row }. Satırdaki Miktar alanı formatı uygun değil.</br>`;
            valid = false;
        } if (!this.checkUnit(rowData["unit"])) {
            message = message + `${row }. Satırdaki Birim alanı formatı uygun değil.</br>`;
            valid = false;
        } if (typeof rowData["unitPrice"] !== 'number') {
            message = message + `${row }. Satırdaki Birim Fiyat alanı formatı uygun değil.</br>`;
            valid = false;
        } if (typeof rowData["allowancePercentage"] !== 'number') {
            message = message + `${row }. Satırdaki İskonto Oranı alanı formatı uygun değil.</br>`;
            valid = false;
        } if (typeof rowData["allowanceAmount"] !== 'number') {
            message = message + `${row }. Satırdaki İskonto Tutarı alanı formatı uygun değil.</br>`;
            valid = false;
        } if (typeof rowData["kdvPercentage"] !== 'number') {
            message = message + `${row}. Satırdaki KDV Oranı alanı formatı uygun değil.</br>`;
            valid = false;
        } else {
            let kdvpercantage = new Decimal(rowData["kdvPercentage"]);
            if (!(kdvpercantage.eq(new Decimal(0)) || kdvpercantage.eq(new Decimal(1)) || kdvpercantage.eq(new Decimal(8)) || kdvpercantage.eq(new Decimal(10)) || kdvpercantage.eq(new Decimal(18)) || kdvpercantage.eq(new Decimal(20)))) {
                message = message + `${row}. Satırdaki KDV Oranı alanı 0,1,8,10,18,20 değerlerinden biri olmalıdır.</br>`;
                valid = false;
            }
        } if (typeof rowData["kdvAmount"] !== 'number') {
            message = message + `${row}. Satırdaki KDV Tutarı alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["gtip"] === undefined || rowData["gtip"] === '' || rowData["gtip"].toString().length !== 12 || isNaN(rowData["gtip"]) || rowData["gtip"] < 0 || rowData["gtip"].toString().includes("+"))) {
            message = message + `${row}. Satırdaki GTİP alanı boş olamaz, harf ve sembol içeremez.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["packageType"] === undefined || rowData["packageType"] === '')) {
            message = message + `${row}. Satırdaki Paket/Kutu Türü alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["deliveryTerms"] === undefined || rowData["deliveryTerms"] === '')) {
            message = message + `${row}. Satırdaki Teslimat Şartı alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["transportModeCode"] === undefined || rowData["transportModeCode"] === '')) {
            message = message + `${row}. Satırdaki Teslimat Gönderim Şekli alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["shipmentId"] === undefined || rowData["shipmentId"] === '' || rowData["shipmentId"] === "Boş Olamaz")) {
            message = message + `${row}. Satırdaki Kargo No alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["citySubdivion"] === undefined || rowData["citySubdivion"] === '' || rowData["citySubdivion"] === "Boş Olamaz")) {
            message = message + `${row}. Satırdaki İlçe alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["city"] === undefined || rowData["city"] === '' || rowData["city"] === "Boş Olamaz")) {
            message = message + `${row}. Satırdaki İl alanı formatı uygun değil.</br>`;
            valid = false;
        } if ((this.props.profileId === "IHRACAT") && (rowData["country"] === undefined || rowData["country"] === '')) {
            message = message + `${row}. Satırdaki Ülke alanı formatı uygun değil.</br>`;
            valid = false;
        }

        return {valid: valid, message: message};
    }

    checkUnit(unit) {
        if (typeof unit !== 'string' || unit === '') {
            return false;
        }
        return true;
    }

    rowToInvoiceLine(rowData) {
        let chargeList = [];
        chargeList.push({
            recordId: null,
            amount: rowData["allowanceAmount"],
            calculatedBy: "AMOUNT",
            direction: -1,
            exemptionReasonCode: null,
            percentage: rowData["allowancePercentage"],
            perUnitAmount: 0.0,
            taxCode: this.getChargeWithCode("0000"),
            invoiceLineId: null,
            withholdingCode: null
        }, {
            recordId: null,
            amount: rowData["kdvAmount"],
            calculatedBy: "AMOUNT",
            direction: 1,
            exemptionReasonCode: null,
            percentage: rowData["kdvPercentage"],
            perUnitAmount: 0.0,
            taxCode: this.getChargeWithCode("0015"),
            invoiceLineId: null,
            withholdingCode: null
        });

        return {
            recordId: null,
            itemCode: null,
            buyersItemIdentification: null,
            manufacturersItemIdentification: null,
            itemId: null,
            itemName: "" + rowData["itemName"],
            quantity: rowData["quantity"],
            unit: "" + rowData["unit"],
            unitPrice: rowData["unitPrice"],
            lineExtensionAmount: 1,
            siparisNo:null,
            siparisDate:null,
            despatchNo:null,
            despatchDate:null,
            gtipIhrac:'',
            lineCode:'',
            oppositeDocNo:'',
            trdDocInvoiceLineCharges: chargeList,
            lineExplanation: rowData["lineExplanation"] ? rowData["lineExplanation"] : "",
            gumrukTakipNo: ((this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") ? rowData["gumrukTakipNo"] : null),
            chargeUnitSerialNumber: ((this.props.invoiceTypeCode === "SARJANLIK") ? rowData["chargeUnitSerialNumber"]: null),
            trdDocInvoiceLineDeliveryDetail: this.props.profileId === "IHRACAT" ? {
                actualPackageId: rowData["actualPackageId"],
                actualPackagePTC: rowData["packageType"],
                actualPackageQuantity: rowData["actualPackageQuantity"],
                buildingName: rowData["buildingName"],
                buildingNumber: rowData["buildingNumber"],
                city: rowData["city"],
                citySubdivion: rowData["citySubdivion"],
                country: rowData["country"],
                deliveryTerms: rowData["deliveryTerms"],
                gtip: rowData["gtip"],
                packageBrand:  rowData["packageBrand"],
                postalZone: rowData["postalZone"],
                recordId: null,
                shipmentId: rowData["shipmentId"],
                streetName: rowData["streetName"],
                transportMeansTypeCode:null,
                transportModeCode:  rowData["transportModeCode"],
            } : null
        };
    }

    static calculate(trdDocInvoiceLine, kdvRounding, fromTotalToUnit) {
        if (fromTotalToUnit === undefined)
            fromTotalToUnit = false;

        if (trdDocInvoiceLine.quantity === "")
            trdDocInvoiceLine.quantity = 1;
        if (trdDocInvoiceLine.unitPrice === "" || trdDocInvoiceLine.unitPrice === null)
            trdDocInvoiceLine.unitPrice = 1;
        if (fromTotalToUnit && new Decimal(trdDocInvoiceLine.quantity).isZero())
            trdDocInvoiceLine.totalPrice = 0;

        let trdDocInvoiceLineCharges = deepCopyObject(trdDocInvoiceLine.trdDocInvoiceLineCharges);
        trdDocInvoiceLineCharges.sort((charge1, charge2) => charge1.taxCode.priority - charge2.taxCode.priority);

        for (let i = 0; i < trdDocInvoiceLineCharges.length; i++) {
            if (trdDocInvoiceLineCharges[i].amount === "")
                trdDocInvoiceLineCharges[i].amount = 0;
            if (trdDocInvoiceLineCharges[i].percentage === "")
                trdDocInvoiceLineCharges[i].percentage = 0;
        }

        let iskonto000Check = true;
        let iskonto2001Check = true;
        let iskonto2002Check = true;
        let iskonto2003Check = true;
        let iskonto2004Check = true;
        let iskonto2005Check = true;

        if (fromTotalToUnit && !trdDocInvoiceLine.totalPrice) {
            trdDocInvoiceLine.totalPrice = new Decimal(trdDocInvoiceLine.quantity).isZero() ? new Decimal(0.00) : new Decimal(1.20).toNumber();
        }

        let baseTaxableAmount = fromTotalToUnit
            ? new Decimal(trdDocInvoiceLine.totalPrice || 0)
            : new Decimal(trdDocInvoiceLine.quantity).mul(new Decimal(trdDocInvoiceLine.unitPrice || 0));

        let withholdingTaxableAmount = new Decimal(0);
        let kdvTaxableAmount = new Decimal(baseTaxableAmount);

        if (!fromTotalToUnit) {
            for (let i = 0; i < trdDocInvoiceLineCharges.length; i++) {
                let lineCharge = trdDocInvoiceLineCharges[i];
                let priority = lineCharge.taxCode.priority;
                let nTaxableAmount = new Decimal(0);

                if (lineCharge.taxCode.calculatedBy === "UNIT") {
                    trdDocInvoiceLineCharges[i].taxableAmount = 0;
                    if (trdDocInvoiceLineCharges[i].calculateFrom === "amount") {
                        if (!new Decimal(trdDocInvoiceLine.quantity).isZero()) {
                            trdDocInvoiceLineCharges[i].perUnitAmount = new Decimal(trdDocInvoiceLineCharges[i].amount || 0)
                                .div(new Decimal(trdDocInvoiceLine.quantity))
                                .toNumber();
                        }
                    } else {
                        trdDocInvoiceLineCharges[i].amount = new Decimal(trdDocInvoiceLineCharges[i].perUnitAmount || 0)
                            .mul(new Decimal(trdDocInvoiceLine.quantity))
                            .toDecimalPlaces(2, (kdvRounding !== undefined ? kdvRounding : Decimal.ROUND_HALF_UP))
                            .toNumber();
                    }
                } else {
                    for (let j = 0; j < i; j++) {
                        let iPriority = trdDocInvoiceLineCharges[j].taxCode.priority;
                        let affectTaxableAmount = trdDocInvoiceLineCharges[j].taxCode.affectTaxableAmount;
                        if (iPriority < priority && affectTaxableAmount === 1) {
                            let chgAmt = new Decimal(trdDocInvoiceLineCharges[j].amount || 0).mul(new Decimal(trdDocInvoiceLineCharges[j].direction || 1));
                            nTaxableAmount = nTaxableAmount.plus(chgAmt);

                            if (trdDocInvoiceLineCharges[j].taxCode.isAffectKdv === 1) {
                                let cCode = trdDocInvoiceLineCharges[j].taxCode.code;
                                if ((cCode === "0000" || cCode === "2001" || cCode === "2002" ||
                                    cCode === "2003" || cCode === "2004" || cCode === "2005")) {
                                    if (cCode === "0000" && iskonto000Check) {
                                        kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                        iskonto000Check = false;
                                    }
                                    if (cCode === "2001" && iskonto2001Check) {
                                        kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                        iskonto2001Check = false;
                                    }
                                    if (cCode === "2002" && iskonto2002Check) {
                                        kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                        iskonto2002Check = false;
                                    }
                                    if (cCode === "2003" && iskonto2003Check) {
                                        kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                        iskonto2003Check = false;
                                    }
                                    if (cCode === "2004" && iskonto2004Check) {
                                        kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                        iskonto2004Check = false;
                                    }
                                    if (cCode === "2005" && iskonto2005Check) {
                                        kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                        iskonto2005Check = false;
                                    }
                                } else {
                                    kdvTaxableAmount = kdvTaxableAmount.plus(chgAmt);
                                }
                            }
                        }
                    }

                    // KDV matrahı
                    if (lineCharge.taxCode.code === "0015") {
                        lineCharge.taxableAmount = kdvTaxableAmount.toNumber();
                    } else {
                        lineCharge.taxableAmount = baseTaxableAmount.plus(nTaxableAmount).toNumber();
                    }

                    if (lineCharge.calculateFrom === "amount") {
                        let taxableDec = new Decimal(lineCharge.taxableAmount || 0);
                        if (!taxableDec.isZero()) {
                            lineCharge.percentage = new Decimal(lineCharge.amount || 0)
                                .div(taxableDec)
                                .mul(100)
                                .toDecimalPlaces(2)
                                .toNumber();
                        }
                    } else {
                        // yüzde bazlı hesap
                        let taxPerc = new Decimal(lineCharge.percentage || 0).div(100);
                        let taxableDec = new Decimal(lineCharge.taxableAmount || 0);

                        if (lineCharge.taxCode.code === "0015") {
                            // KDV Hesabı
                            lineCharge.amount = taxableDec
                                .mul(taxPerc)
                                .toDecimalPlaces(2, (kdvRounding !== undefined && kdvRounding !== null) ? kdvRounding : Decimal.ROUND_HALF_UP)
                                .toNumber();
                        } else if (lineCharge.taxCode.code === "0003" || lineCharge.taxCode.code === "0011") {
                            // Stopaj vs.
                            lineCharge.nakitTeminatiAmount = taxableDec
                                .mul(new Decimal(lineCharge.nakitTeminati || 0).div(100))
                                .toDecimalPlaces(2, (kdvRounding !== undefined ? kdvRounding : Decimal.ROUND_HALF_UP))
                                .toNumber();
                            lineCharge.avansMahsubuAmount = taxableDec
                                .mul(new Decimal(lineCharge.avansMahsubu || 0).div(100))
                                .toDecimalPlaces(2, (kdvRounding !== undefined ? kdvRounding : Decimal.ROUND_HALF_UP))
                                .toNumber();
                            lineCharge.amount = taxableDec
                                .mul(taxPerc)
                                .toDecimalPlaces(2, (kdvRounding !== undefined ? kdvRounding : Decimal.ROUND_HALF_UP))
                                .toNumber();

                            lineCharge.amount = new Decimal(lineCharge.amount)
                                .minus((lineCharge.amount / 100) * lineCharge.avansMahsubu)
                                .toNumber();
                        } else {
                            if (!(lineCharge.taxCode.code === "9077" && lineCharge.percentage === 0)) {
                                lineCharge.amount = taxableDec
                                    .mul(taxPerc)
                                    .toDecimalPlaces(2, (kdvRounding !== undefined ? kdvRounding : Decimal.ROUND_HALF_UP))
                                    .toNumber();
                            }
                        }
                    }

                    if (lineCharge.taxCode.code === "0015") {
                        withholdingTaxableAmount = new Decimal(lineCharge.amount || 0);
                    }
                    if (lineCharge.taxCode.code === "9015") {
                        // Tevkifat hesapları
                        lineCharge.taxableAmount = withholdingTaxableAmount.toNumber();
                        let wTaxDec = new Decimal(lineCharge.taxableAmount);

                        if (lineCharge.calculateFrom === "amount") {
                            if (!wTaxDec.isZero()) {
                                lineCharge.percentage = new Decimal(lineCharge.amount || 0)
                                    .div(wTaxDec)
                                    .mul(100)
                                    .toDecimalPlaces(2)
                                    .toNumber();
                            }
                        } else {
                            lineCharge.amount = wTaxDec
                                .mul(new Decimal(lineCharge.percentage || 0).div(100))
                                .toDecimalPlaces(2, (kdvRounding !== undefined ? kdvRounding : Decimal.ROUND_HALF_UP))
                                .toNumber();
                        }
                    }
                }

            }
        }
        else {
                let nTaxableAmount = new Decimal(trdDocInvoiceLine.totalPrice || 0);
                for (let i = trdDocInvoiceLineCharges.length - 1; i > -1; i--) {
                    let lineCharge = trdDocInvoiceLineCharges[i];
                    let taxPerc = new Decimal(lineCharge.percentage || 0).div(100);
                    let baseDec = new Decimal(trdDocInvoiceLine.quantity || 1);

                    if (lineCharge.calculateFrom === "amount") {
                        let amtDec = new Decimal(lineCharge.amount || 0);
                        if (lineCharge.taxCode.code === "0015") {
                            nTaxableAmount = nTaxableAmount.minus(amtDec);
                        } else if (["0000","2001","2002","2003","2004","2005"].includes(lineCharge.taxCode.code)) {
                            nTaxableAmount = nTaxableAmount.plus(amtDec);
                        }
                        lineCharge.percentage = new Decimal(lineCharge.amount || 0)
                            .div(nTaxableAmount)
                            .mul(100)
                            .toDecimalPlaces(2)
                            .toNumber();
                        trdDocInvoiceLine.unitPrice = nTaxableAmount.div(baseDec).toDecimalPlaces(8).toNumber();
                        lineCharge.taxableAmount = new Decimal(trdDocInvoiceLine.unitPrice).mul(baseDec)
                            .toDecimalPlaces(2)
                            .toNumber();
                    } else {
                        if (lineCharge.taxCode.code === "0015") {
                            // KDV dahil toplamdan net kdv ve matrah bulma
                            let kdvAmount = nTaxableAmount.div((new Decimal(1).plus(taxPerc))).toDecimalPlaces(2, Decimal.ROUND_HALF_DOWN);
                            lineCharge.amount = nTaxableAmount.minus(kdvAmount).toDecimalPlaces(2).toNumber();
                            nTaxableAmount = kdvAmount;
                            trdDocInvoiceLine.unitPrice = nTaxableAmount.div(baseDec).toDecimalPlaces(8).toNumber();
                            lineCharge.taxableAmount = new Decimal(trdDocInvoiceLine.unitPrice).mul(baseDec)
                                .toDecimalPlaces(2)
                                .toNumber();
                        } else if (["0000","2001","2002","2003","2004","2005"].includes(lineCharge.taxCode.code)) {
                            // İskonto hesaplaması
                            let kdvAmount = nTaxableAmount.div((new Decimal(1).minus(taxPerc))).toDecimalPlaces(2, Decimal.ROUND_HALF_DOWN);
                            lineCharge.amount = kdvAmount.minus(nTaxableAmount).toDecimalPlaces(2).toNumber();
                            nTaxableAmount = kdvAmount;
                            trdDocInvoiceLine.unitPrice = nTaxableAmount.div(baseDec).toDecimalPlaces(8).toNumber();
                            lineCharge.taxableAmount = new Decimal(trdDocInvoiceLine.unitPrice).mul(baseDec)
                                .toDecimalPlaces(2)
                                .toNumber();
                        }
                    }
                }
            }

            let tCharges = deepCopyObject(trdDocInvoiceLine.trdDocInvoiceLineCharges);
            for (let i = 0; i < trdDocInvoiceLineCharges.length; i++) {
                for (let j = 0; j < tCharges.length; j++) {
                    if (trdDocInvoiceLineCharges[i].taxCode.code === tCharges[j].taxCode.code) {
                        tCharges[j] = deepCopyObject(trdDocInvoiceLineCharges[i]);
                        break;
                    }
                }
            }
            trdDocInvoiceLine.trdDocInvoiceLineCharges = deepCopyObject(tCharges);

            let lineExtDec = new Decimal(trdDocInvoiceLine.quantity || 0)
                .mul(new Decimal(trdDocInvoiceLine.unitPrice || 0));

            for (let i = 0; i < trdDocInvoiceLine.trdDocInvoiceLineCharges.length; i++) {
                let lineCharge = trdDocInvoiceLine.trdDocInvoiceLineCharges[i];
                let amtDec = new Decimal(lineCharge.amount || 0);
                if((["0000","2001","2002","2003","2004","2005"].includes(lineCharge.taxCode.code)) && amtDec != null){
                    lineExtDec = lineExtDec.minus(amtDec);
                }
                if((["0001","3001","3002"].includes(lineCharge.taxCode.code)) && amtDec != null){
                    lineExtDec = lineExtDec.plus(amtDec);
                }
            }

            trdDocInvoiceLine.lineExtensionAmount = lineExtDec.toDecimalPlaces(2).toNumber();

            if(!fromTotalToUnit) {
                let totalPrice = new Decimal(trdDocInvoiceLine.unitPrice || 0)
                    .mul(new Decimal(trdDocInvoiceLine.quantity || 0));

                for (let i = 0; i < trdDocInvoiceLine.trdDocInvoiceLineCharges.length; i++) {
                    let c = trdDocInvoiceLine.trdDocInvoiceLineCharges[i];
                    let amtDec = new Decimal(c.amount || 0);
                    if(c.taxCode.code === "0003" || c.taxCode.code === "0011"){
                        let nakitTeminatiDec = new Decimal(c.nakitTeminatiAmount || 0);
                        let avansMahsubuDec = new Decimal(c.avansMahsubuAmount || 0);
                        totalPrice = totalPrice.plus(
                            (new Decimal(c.direction || 1)
                                .mul(amtDec.plus(nakitTeminatiDec).plus(avansMahsubuDec)))
                        );
                    } else {
                        totalPrice = totalPrice.plus(new Decimal(c.direction || 1).mul(amtDec));
                    }
                }
                trdDocInvoiceLine.totalPrice = totalPrice.toDecimalPlaces(2).toNumber();
            }

            return trdDocInvoiceLine;
        }



        onStockChange(data, index) {
        let self = this;
        if (data.hasOwnProperty("stock")) {
            let trdDocInvoiceLines = deepCopyObject(self.state.trdDocInvoiceLines);
            let stock = data.stock;
            if (stock.defaultCurrencyCode === self.props.documentCurrencyCode) {
                trdDocInvoiceLines = this.setTrdDocInvoiceLines();
                trdDocInvoiceLines = self.setStock(stock, trdDocInvoiceLines, index, self.props.direction, true);
                self.props.listener(trdDocInvoiceLines);
                self.setState({trdDocInvoiceLines});
            } else {
                Swal({
                    title: 'Yine de uygulansın mı?',
                    html: 'Seçmeye çalıştığınız <strong style="font-weight: bold;">Stok Para Birimi(' + stock.defaultCurrencyCode + ')</strong> ile <strong style="font-weight: bold;">Doküman Para Birimi(' + self.props.documentCurrencyCode + ')</strong> uyuşmuyor.',
                    showCancelButton: true,
                    confirmButtonText: 'Tamam',
                    cancelButtonText: 'İptal',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.value) {
                        trdDocInvoiceLines = self.setStock(stock, trdDocInvoiceLines, index, self.props.direction, false);
                        self.props.listener(trdDocInvoiceLines);
                        self.setState({trdDocInvoiceLines});
                    }
                });
            }

            if (!stock.customerId) {
                Swal({
                    title: 'Stok kayıt edilsin mi?',
                    html: 'Seçmiş olduğunuz stok(<strong style="font-weight: bold;">' + (stock.code ? stock.code + ' - ' : '') + stock.name + ')</strong> sisteminizde kayıtlı değildir. Kayıt etmek ister misiniz?',
                    showCancelButton: true,
                    confirmButtonText: 'Evet',
                    cancelButtonText: 'Hayır',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.value) {
                        this.setState({stock: stock, stockModal: true, isCreate: false});
                    }
                });
            }
        }
    }

    setStock(stock, trdDocInvoiceLines, index, direction, setUnitPrice) {
        if((this.props.profileId === "IHRACAT"))
            trdDocInvoiceLines[index]["trdDocInvoiceLineDeliveryDetail"]["gtip"] = stock.gtip;

        trdDocInvoiceLines[index]["itemCode"] = stock.code;
        trdDocInvoiceLines[index]["explanation"] = stock.explanation;
        trdDocInvoiceLines[index]["manufacturersItemIdentification"] = stock.manufacturersItemIdentification;
        trdDocInvoiceLines[index]["buyersItemIdentification"] = stock.buyersItemIdentification;
        trdDocInvoiceLines[index]["itemName"] = stock.name;
        trdDocInvoiceLines[index]["unit"] = stock.baseUnit;
        trdDocInvoiceLines[index]["unitPrice"] = setUnitPrice ? (this.props.direction === "In" ? stock.defPricePurchase : stock.defPriceSell) : 0.00;
        let trdDocInvoiceLineCharges = trdDocInvoiceLines[index].trdDocInvoiceLineCharges;
        let kdvIndex = (trdDocInvoiceLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf("0015");
        if (kdvIndex !== -1 && this.props.invoiceTypeCode !== 'KONAKLAMAVERGISI') {
            trdDocInvoiceLineCharges[kdvIndex]["calculateFrom"] = "percentage";
            trdDocInvoiceLineCharges[kdvIndex]["percentage"] = direction === "In" ? stock.kdvPurchase : stock.kdvSell;
            trdDocInvoiceLineCharges[kdvIndex]["exemptionReasonCode"] = direction === "In" ? stock.kdvPurchaseExemption : stock.kdvSellExemption;
        }

        if(stock.withHoldingCode !== "000" && this.props.invoiceTypeCode === "TEVKIFAT"){
            let selectedCharge = {
                calculatedBy: "AMOUNT",
                code: "9015",
                direction: -1,
                inv: 1,
                isAffectKdv: 0,
                longName: "KDV TEVKİFATI",
                mm: 0,
                priority: 5,
                recordId: 6,
                shortName: "KDV TEVKİFATI",
                smm: 1 };

            trdDocInvoiceLineCharges.push({
                recordId: null,
                amount: 0,
                calculatedBy: selectedCharge.calculatedBy,
                direction: selectedCharge.direction,
                priority: selectedCharge.priority,
                exemptionReasonCode: null,
                percentage: 0.0,
                perUnitAmount: 0.0,
                taxCode: selectedCharge,
                invoiceLineId: null,
                withholdingCode: null,
                allowanceReason: null
            });

            if(stock.withHoldingCode !== null ){
                let kdvTeminatiIndex = (trdDocInvoiceLineCharges.map(function (charge) {
                    return charge.taxCode.code;
                })).indexOf("9015");
                if(kdvTeminatiIndex !== -1 ) {
                    let withholdingPercentage;
                    if(stock.withHoldingCode.toString().includes("_")){
                        trdDocInvoiceLineCharges[kdvTeminatiIndex]["percentage"] = stock.withHoldingCode.split("_")[1];
                        trdDocInvoiceLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode.split("_")[0];
                    }else {
                        this.props.withholdingTypes.map(function (withholdingType) {
                            if(stock.withHoldingCode.toString() !== "0" && withholdingType.code === stock.withHoldingCode.toString()){
                                withholdingPercentage = withholdingType.percentage;
                            }
                        });
                        if(stock.withHoldingCode.toString() !== "0"){
                            trdDocInvoiceLineCharges[kdvTeminatiIndex]["percentage"] = withholdingPercentage;
                            trdDocInvoiceLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode;
                        }
                    }
                }
            }
        }

        trdDocInvoiceLines[index] = InvoiceLines.calculate(trdDocInvoiceLines[index], ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
        trdDocInvoiceLines[index]["includingVat"] = trdDocInvoiceLines[index]["unitPrice"] + (trdDocInvoiceLines[index]["unitPrice"] * trdDocInvoiceLines[index]["trdDocInvoiceLineCharges"][kdvIndex]["percentage"] / 100);
        return trdDocInvoiceLines;
    }

    async createStock(option, index, from) {
        let stock, params;
        let hasStock = false;
        if (from === "itemCode") {
            let stockCode = option.value.length === 13 ? "0" + option.value.toString() : (option.value.length >= 16 ? option.value.substr(2, 14) : option.value);
            params = {
                url: '/stock/getByCode',
                method: "post",
                data: stockCode
            };

            await request(params)
                .then(response => {
                    let ownStock = response.data;
                    if (ownStock.recordId && ownStock.recordId > 0) {
                        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
                        trdDocInvoiceLines = this.setStock(ownStock, trdDocInvoiceLines, index, this.props.direction, true);
                        this.props.listener(trdDocInvoiceLines);
                        this.setState({trdDocInvoiceLines});
                        hasStock = true;
                    }
                }).catch(function (error) {
                    showAxiosError(error);
                });


            if (!hasStock) {
                params = {
                    url: '/chemistStock/getByCode',
                    method: "post",
                    data: stockCode
                };

                await request(params)
                    .then(response => {
                        let chemistStock = response.data;
                        if (chemistStock.recordId && chemistStock.recordId > 0) {
                            stock = {
                                alias: "",
                                baseUnit: chemistStock.baseUnit,
                                code: chemistStock.code,
                                defPricePurchase: chemistStock.defPricePurchase,
                                defPriceSell: chemistStock.defPriceSell,
                                defaultCurrencyCode: chemistStock.defaultCurrencyCode,
                                explanation: "",
                                itemType: {recordId: 1, itemName: "MAL"},
                                kdvPurchase: chemistStock.kdvPurchase,
                                kdvSell: chemistStock.kdvSell,
                                kdvSellExemption: null,
                                kdvPurchaseExemption: null,
                                name: chemistStock.name,
                                otv: 0,
                                recordId: null,
                                stockGroup: 1,
                                gtip: ""
                            };
                        }
                    }).catch(function (error) {
                        showAxiosError(error);
                    });
            }
        } else if (from === "itemName") {
            let stockName = option.value;
            params = {
                url: '/stock/getByCode',
                method: "post",
                data: stockName
            };

            await request(params)
                .then(response => {
                    let ownStock = response.data;
                    if (ownStock.recordId && ownStock.recordId > 0) {
                        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
                        trdDocInvoiceLines = this.setStock(ownStock, trdDocInvoiceLines, index, this.props.direction, true);
                        this.props.listener(trdDocInvoiceLines);
                        this.setState({trdDocInvoiceLines});
                        hasStock = true;
                    }
                }).catch(function (error) {
                    showAxiosError(error);
                });


            if (!hasStock) {
                params = {
                    url: '/veterinarianStock/getByName',
                    method: "post",
                    data: stockName
                };

                await request(params)
                    .then(response => {
                        let veterinarianStock = response.data;
                        if (veterinarianStock.recordId && veterinarianStock.recordId > 0) {
                            stock = {
                                alias: "",
                                baseUnit: veterinarianStock.baseUnit,
                                code: veterinarianStock.code,
                                defPricePurchase: veterinarianStock.defPricePurchase,
                                defPriceSell: veterinarianStock.defPriceSell,
                                defaultCurrencyCode: veterinarianStock.defaultCurrencyCode,
                                explanation: "",
                                itemType: {recordId: 1, itemName: "MAL"},
                                kdvPurchase: veterinarianStock.kdvPurchase,
                                kdvSell: veterinarianStock.kdvSell,
                                kdvSellExemption: null,
                                kdvPurchaseExemption: null,
                                name: veterinarianStock.name,
                                otv: 0,
                                recordId: null,
                                stockGroup: 1,
                                gtip: ""
                            };
                        }
                    }).catch(function (error) {
                        showAxiosError(error);
                    });
            }
        }

        if (!hasStock) {
            if (stock === undefined || stock === null) {
                stock = {
                    alias: "",
                    baseUnit: "C62",
                    code: from !== "itemName" ? option.value : "",
                    defPricePurchase: 1,
                    defPriceSell: 1,
                    defaultCurrencyCode: this.props.documentCurrencyCode,
                    explanation: "",
                    itemType: {recordId: 1, itemName: "MAL"},
                    kdvPurchase: 20,
                    kdvSell: 20,
                    kdvSellExemption: null,
                    kdvPurchaseExemption: null,
                    name: from === "itemName" ? option.value : "",
                    otv: 0,
                    recordId: null,
                    stockGroup: 1,
                    gtip: ""
                };
            }

            this.setState({stock: stock, stockModal: true, isCreate: false, index: index});
        }
    }

    setStocks(stock, isSetParent) {
        let index = this.state.index;
        if (!isSetParent) {
            this.setState({stockModal: false});
        } else {
            let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
            trdDocInvoiceLines = this.setTrdDocInvoiceLines();
            trdDocInvoiceLines[index]["itemCode"] = stock.code;
            trdDocInvoiceLines[index]["explanation"] = stock.explanation;
            trdDocInvoiceLines[index]["manufacturersItemIdentification"] = stock.manufacturersItemIdentification;
            trdDocInvoiceLines[index]["buyersItemIdentification"] = stock.buyersItemIdentification;
            trdDocInvoiceLines[index]["itemName"] = stock.name;
            trdDocInvoiceLines[index]["unit"] = stock.baseUnit;
            trdDocInvoiceLines[index]["unitPrice"] = this.props.direction === "In" ? stock.defPricePurchase : stock.defPriceSell;
            if((this.props.profileId === "IHRACAT"))
                trdDocInvoiceLines[index]["trdDocInvoiceLineDeliveryDetail"]["gtip"] = stock.gtip;
            let trdDocInvoiceLineCharges = trdDocInvoiceLines[index].trdDocInvoiceLineCharges;
            let kdvIndex = (trdDocInvoiceLineCharges.map(function (charge) {
                return charge.taxCode.code;
            })).indexOf("0015");
            if (kdvIndex !== -1) {
                trdDocInvoiceLineCharges[kdvIndex]["percentage"] = this.props.direction === "In" ? stock.kdvPurchase : stock.kdvSell;
                trdDocInvoiceLineCharges[kdvIndex]["exemptionReasonCode"] = this.props.direction === "In" ? stock.kdvPurchaseExemption : stock.kdvSellExemption;
            }

            let otvIndex = (trdDocInvoiceLineCharges.map(function (charge) {
                return charge.taxCode.code;
            })).indexOf("0071");
            if (otvIndex !== -1)
                trdDocInvoiceLineCharges[otvIndex]["percentage"] = stock.otv;


            if(stock.withHoldingCode !== "000" && this.props.invoiceTypeCode === "TEVKIFAT"){
              let selectedCharge = {
                  calculatedBy: "AMOUNT",
                  code: "9015",
                  direction: -1,
                  inv: 1,
                  isAffectKdv: 0,
                  longName: "KDV TEVKİFATI",
                  mm: 0,
                  priority: 5,
                  recordId: 6,
                  shortName: "KDV TEVKİFATI",
                  smm: 1 };

                trdDocInvoiceLineCharges.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: selectedCharge.calculatedBy,
                    direction: selectedCharge.direction,
                    priority: selectedCharge.priority,
                    exemptionReasonCode: null,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: selectedCharge,
                    invoiceLineId: null,
                    withholdingCode: null,
                    allowanceReason: null
                });

                let kdvTeminatiIndex = (trdDocInvoiceLineCharges.map(function (charge) {
                    return charge.taxCode.code;
                })).indexOf("9015");
                if(kdvTeminatiIndex !== -1 ) {
                    let withholdingPercentage;
                    if(stock.withHoldingCode.toString().includes("_")){
                        trdDocInvoiceLineCharges[kdvTeminatiIndex]["percentage"] = stock.withHoldingCode.split("_")[1];
                        trdDocInvoiceLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode.split("_")[0];
                    }else {
                        this.props.withholdingTypes.map(function (withholdingType) {
                            if(stock.withHoldingCode.toString() !== "0" && withholdingType.code === stock.withHoldingCode.toString()){
                                withholdingPercentage = withholdingType.percentage;
                            }
                        });
                        if(stock.withHoldingCode.toString() !== "0"){
                            trdDocInvoiceLineCharges[kdvTeminatiIndex]["percentage"] = withholdingPercentage;
                            trdDocInvoiceLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode;
                        }
                    }
                }
            }

            trdDocInvoiceLines[index] = InvoiceLines.calculate(trdDocInvoiceLines[index], ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
            this.props.listener(trdDocInvoiceLines);
            this.setState({trdDocInvoiceLines: trdDocInvoiceLines, stockModal: false});
        }
    }

    onChange(e, index) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        trdDocInvoiceLines[index][e.name] = (e.name === "unitPrice" || e.name === "quantity") && (e.value === "," || e.value === ".") ? "0." :
            ((e.name === "quantity" && e.value !== "") || (e.name === "unitPrice" && e.value !== "")) ? (new Decimal(e.value)).toNumber() : e.value;

        if (e.name !== "itemName" &&
            e.name !== "gumrukTakipNo" &&
            e.name !== "unit" &&
            e.value !== "") {
            if (trdDocInvoiceLines[index] && trdDocInvoiceLines[index].trdDocInvoiceLineCharges && trdDocInvoiceLines[index].trdDocInvoiceLineCharges.length > 0) {
                for (let i = 0; i < trdDocInvoiceLines[index].trdDocInvoiceLineCharges.length; i++) {
                    if (trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage === "")
                        trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage = 0;
                    if (trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount === "")
                        trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount = 0;
                }
            }

            let vatPercentage = trdDocInvoiceLines[index].trdDocInvoiceLineCharges.filter((tCharge) => {
                return (tCharge.taxCode.code === "0015")
            });
            if (e.name === "unitPrice") {
                trdDocInvoiceLines[index].includingVat = trdDocInvoiceLines[index].unitPrice + (trdDocInvoiceLines[index].unitPrice * (vatPercentage[0].percentage / 100))
            }

            if (e.name === "includingVat") {
                let vat = vatPercentage[0].percentage / 100;
                trdDocInvoiceLines[index].unitPrice = e.value / (1 + vat);
            }

            trdDocInvoiceLines[index] = InvoiceLines.calculate(trdDocInvoiceLines[index], ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
            this.props.listener(trdDocInvoiceLines);
        }
        if (e.name === "itemName" ||
            e.name === "gumrukTakipNo" ||
            e.name === "unit") {
            for (let i = 0; i < trdDocInvoiceLines[index].trdDocInvoiceLineCharges.length; i++) {
                trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount = trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount === "" ? new Decimal(0) : trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount;
                trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage = trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage === "" ? new Decimal(0) : trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage;
            }
            this.props.listener(trdDocInvoiceLines);
        }
        this.setState({trdDocInvoiceLines});
    }

    onChangeTevkifatIade(e, index, chargeCode) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let line = trdDocInvoiceLines[index];
        let trdDocInvoiceLineCharges = deepCopyObject(line.trdDocInvoiceLineCharges);
        let chargeIndex = (trdDocInvoiceLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf(chargeCode);
        let lineCharge = line.trdDocInvoiceLineCharges[chargeIndex];

        lineCharge[e.name] = e.value !== "" ? (new Decimal(e.value)).toNumber() : e.value;

        if (e.name === "rateOfReturnedGood") {
            if (e.value > 100) {
                return Alert.error("İade Edilen Mal Oranı 100'den Büyük Olamaz!.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
            let vatRefundAmount = (e.value !== "" || e.value !== null) ? e.value : 1;
            let tevkifatsizKdvTutari = (lineCharge.tevkifatsizKdvTutari !== "" || lineCharge.tevkifatsizKdvTutari !== null) ? lineCharge.tevkifatsizKdvTutari : 1;
            lineCharge["vatRefundAmount"] = (vatRefundAmount / 100) * tevkifatsizKdvTutari;
        } else if (e.name === "tevkifatsizKdvTutari") {
            let vatRefundAmount = (lineCharge.rateOfReturnedGood !== null || lineCharge.rateOfReturnedGood !== "")  ?  lineCharge.rateOfReturnedGood : 1;
            let tevkifatsizKdvTutari = (e.value !== "" || e.value !== null) ? e.value : new Decimal(1);
            lineCharge["vatRefundAmount"] = (vatRefundAmount / 100) * tevkifatsizKdvTutari;
        }
        line.trdDocInvoiceLineCharges[chargeIndex] = deepCopyObject(lineCharge);
        trdDocInvoiceLines[index] = deepCopyObject(line);
        this.props.listener(trdDocInvoiceLines);
        this.setState({trdDocInvoiceLines});
    }

    async changeLineChargeValue(e, chargeCode, index, calculatedBy) {
        const {value} = e;
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let trdDocInvoiceLine = trdDocInvoiceLines[index];
        let trdDocInvoiceLineCharges = deepCopyObject(trdDocInvoiceLine.trdDocInvoiceLineCharges);
        let chargeIndex = (trdDocInvoiceLineCharges.map(function (charge) {
            return charge.taxCode.code;
        })).indexOf(chargeCode);
        if (value === "") {
            trdDocInvoiceLines[index].trdDocInvoiceLineCharges[chargeIndex][calculatedBy] = "";
            this.props.listener(trdDocInvoiceLines);
            this.setState({trdDocInvoiceLines});
        } else {
            trdDocInvoiceLineCharges[chargeIndex][calculatedBy] = new Decimal(value).toNumber();
            trdDocInvoiceLineCharges[chargeIndex]["calculateFrom"] = calculatedBy;
            trdDocInvoiceLine.trdDocInvoiceLineCharges = deepCopyObject(trdDocInvoiceLineCharges);
            trdDocInvoiceLines[index] = InvoiceLines.calculate(trdDocInvoiceLine, ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
            let kdvAmount = trdDocInvoiceLine.unitPrice * e.value / 100;
            trdDocInvoiceLines[index]["includingVat"] = trdDocInvoiceLine.unitPrice + kdvAmount;
            this.props.listener(trdDocInvoiceLines);
            this.setState({trdDocInvoiceLines});
        }
    }

    closeInvoiceLineItsUtsModal() {
        this.setState({invoiceLineItsUtsModal: false});
    }

    addItsUtsLine(index) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let trdDocInvoiceLine = deepCopyObject(trdDocInvoiceLines[index]);
        if (trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes === undefined || trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes === null) {
            trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes = [{
                productModelType: null,
                productModelCode: null,
                recordId: null
            }]
        } else {
            trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes.push({
                productModelType: null,
                productModelCode: null,
                recordId: null
            });
        }
        trdDocInvoiceLines[index] = trdDocInvoiceLine;
        this.setState({trdDocInvoiceLines: trdDocInvoiceLines});
    }

    addItsUtsInformationLine(index) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let trdDocInvoiceLine = deepCopyObject(trdDocInvoiceLines[index]);
        const { quantity } = this.state.trdDocInvoiceLines[index];

        if (trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes === undefined ||
            trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes === null ||
            trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes?.length < quantity) {
            trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes = [];

            const currentList = this.state.trdDocInvoiceLines[index].trdDocInvoiceLineProductModelCodes || [];

            const newItems = Array.from({ length: quantity - currentList.length }, () => ({
                productModelType: null,
                productModelCode: null,
                recordId: null
            }));

            const updatedList = [
                ...currentList,
                ...newItems
            ].slice(0, currentList.length + quantity);

            this.setState((prevState) => {
                const newTrdDocInvoiceLines = [...prevState.trdDocInvoiceLines];
                newTrdDocInvoiceLines[index].trdDocInvoiceLineProductModelCodes = updatedList;

                return { trdDocInvoiceLines: newTrdDocInvoiceLines };
            });

        } else if (trdDocInvoiceLine.trdDocInvoiceLineProductModelCodes.length > trdDocInvoiceLine.quantity) {

            const currentList = this.state.trdDocInvoiceLines[index].trdDocInvoiceLineProductModelCodes;
            const updatedList = [
                ...currentList
            ].slice(0, quantity);

            this.setState((prevState) => {
                const newTrdDocInvoiceLines = [...prevState.trdDocInvoiceLines];
                newTrdDocInvoiceLines[index].trdDocInvoiceLineProductModelCodes = updatedList;

                return { trdDocInvoiceLines: newTrdDocInvoiceLines };
            });
        }
        this.setState({invoiceLineItsUtsModal: true, index: index});
    }

    setInvoiceLineItsUts(invoiceLine, index) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        trdDocInvoiceLines[index] = invoiceLine;
        this.setState({trdDocInvoiceLines: trdDocInvoiceLines});
        this.props.listener(trdDocInvoiceLines);
    }

    addInvoiceLine(showModal) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let chargeList = [];
        if (this.props.invoiceTypeCode === 'KONAKLAMAVERGISI') {
            chargeList.push(
                {
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 1.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                },{
                recordId: null,
                amount: 0,
                calculatedBy: "AMOUNT",
                direction: -1,
                exemptionReasonCode: null,
                exemptionReason: null,
                taxableAmount: 1.0,
                percentage: 0.0,
                perUnitAmount: 0.0,
                taxCode: this.getChargeWithCode("0015"),
                invoiceLineId: null,
                withholdingCode: null
            });
        } else {
            chargeList.push({
                recordId: null,
                amount: 0,
                calculatedBy: "AMOUNT",
                direction: -1,
                exemptionReasonCode: null,
                taxableAmount: 1.0,
                percentage: 0.0,
                perUnitAmount: 0.0,
                taxCode: this.getChargeWithCode("0000"),
                invoiceLineId: null,
                withholdingCode: null
            }, {
                recordId: null,
                amount: VirtualHost.conf.resourcePrefix === "eczacikart" ? 0.10 : 0.20,
                calculatedBy: "AMOUNT",
                direction: 1,
                exemptionReasonCode: null,
                taxableAmount: 1.0,
                percentage: VirtualHost.conf.resourcePrefix === "eczacikart" ? 10.0 : 20.0,
                perUnitAmount: 0.0,
                taxCode: this.getChargeWithCode("0015"),
                invoiceLineId: null,
                withholdingCode: null
            });
        }

        trdDocInvoiceLines.push({
            recordId: null,
            lineNumber:null,
            itemCode: null,
            manufacturersItemIdentification: null,
            buyersItemIdentification: null,
            itemId: null,
            itemName: '',
            quantity: 1,
            unit: 'C62',
            unitPrice: 1,
            totalPrice: VirtualHost.conf.resourcePrefix === "eczacikart" ? 1.10 : 1.20,
            lineExtensionAmount: 1,
            siparisNo:'',
            siparisDate:null,
            despatchDate:null,
            despatchNo:'',
            gtipIhrac:'',
            lineCode:'',
            trdDocInvoiceLineCharges: chargeList,
            trdDocInvoiceLineDeliveryDetail: this.props.profileId === "IHRACAT" ? {
                actualPackageId: "",
                actualPackagePTC: "1A",
                actualPackageQuantity: "",
                buildingName: "",
                buildingNumber: "",
                city: "",
                citySubdivion: "",
                country: "",
                beyanEdilenKiymetDegeri:"",
                deliveryTerms: "DAF",
                gtip: "",
                packageBrand: "",
                postalZone: "",
                recordId: null,
                shipmentId: "",
                streetName: "",
                transportMeansTypeCode: "",
                transportModeCode: "1"
            } : null
        });
        this.props.listener(trdDocInvoiceLines);
        this.setState({trdDocInvoiceLines});
        if (showModal) {
            this.editInvoiceLine(trdDocInvoiceLines.length - 1);
        }
    }

    editInvoiceLine(index) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        let trdDocInvoiceLine = trdDocInvoiceLines[index];
        this.setState({invoiceLineModal: true, index: index, invoiceLine: trdDocInvoiceLine});
    }

    editLineCharges(e) {
        let addedLineCharges = deepCopyObject(this.state.addedLineCharges);
        let addedLineKdvExemption= null;
        let addedLineOtvExemption= null;

        if (!this.props.isCreate) {
            //tüm satırlarda ortak olan vergiler(addedLineCharges) edit için belirlendi.
            let allCharges = [];
            addedLineCharges = [];
            let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
            let smallerLengthCharges = trdDocInvoiceLines[0].trdDocInvoiceLineCharges;
            allCharges = allCharges.concat(smallerLengthCharges);
            for (let i = 1; i < trdDocInvoiceLines.length; i++) {
                if (trdDocInvoiceLines[i].trdDocInvoiceLineCharges.length < smallerLengthCharges.length) {
                    smallerLengthCharges = trdDocInvoiceLines[i].trdDocInvoiceLineCharges;
                }
                allCharges = allCharges.concat(trdDocInvoiceLines[i].trdDocInvoiceLineCharges);
            }

            for (let i = 0; i < smallerLengthCharges.length; i++) {
                let tCharge = smallerLengthCharges[i];
                let countCharge = 0;
                for (let j = 0; j < allCharges.length; j++) {
                    //if (tCharge.taxCode.code === allCharges[j].taxCode.code && tCharge.taxCode.code !== "0015" && tCharge.taxCode.code !== "0000") {
                         if (tCharge.taxCode.code === allCharges[j].taxCode.code ) {
                        countCharge++;
                    }
                }
                if (countCharge === trdDocInvoiceLines.length) {
                    addedLineCharges.push(tCharge);
                }
            }

            //KDV Exemption
            let chargesWithKDVExemption = trdDocInvoiceLines.map(line => line.trdDocInvoiceLineCharges.
                                                        filter(charge => charge.taxCode.code === "0015" && charge.exemptionReason !== null &&
                                                        charge.exemptionReasonCode !== null && charge.percentage === 0)[0]).filter(Boolean);
            if( chargesWithKDVExemption[0] !== undefined && chargesWithKDVExemption.length === trdDocInvoiceLines.length) {
                let compareTo =  chargesWithKDVExemption[0].exemptionReasonCode;
                if(compareTo!==undefined && chargesWithKDVExemption.filter(item => item.exemptionReasonCode && item.exemptionReasonCode === compareTo).length === trdDocInvoiceLines.length){
                    addedLineKdvExemption = {code: compareTo };
                }
            }

            //OTV Exemption
            let chargesWithOTVExemption = trdDocInvoiceLines.map(line => line.trdDocInvoiceLineCharges.
                                                            filter(charge => charge.taxCode.code === "0071" && charge.exemptionReason !== null &&
                                                            charge.exemptionReasonCode !== null && charge.percentage === 0)[0]).filter(Boolean);
            if( chargesWithOTVExemption[0] !== undefined && chargesWithOTVExemption.length === trdDocInvoiceLines.length) {
                let compareTo =  chargesWithOTVExemption[0].exemptionReasonCode;
                if(compareTo!==undefined && chargesWithOTVExemption.filter(item => item.exemptionReasonCode && item.exemptionReasonCode === compareTo).length === trdDocInvoiceLines.length){
                    addedLineOtvExemption = {code: compareTo };
                }
            }
        }
        this.setState({lineChargeModal: true,
                            addedLineCharges: addedLineCharges,
                            addedLineKdvExemption: addedLineKdvExemption,
                            addedLineOtvExemption:addedLineOtvExemption
        });
    }

    setLineCharges(newAddedLineCharges,addedLineKdvExemption) {
        let addedLineCharges = deepCopyObject(this.state.addedLineCharges);
        let willRemoveCharges = [];
        for (let i = 0; i < addedLineCharges.length; i++) {
            if(addedLineCharges[i].taxCode.code !== "0000" && addedLineCharges[i].taxCode.code !== "0015"){
                let chargeIndex = (newAddedLineCharges.map(function (charge) {
                    return charge.taxCode.code;
                })).indexOf(addedLineCharges[i].taxCode.code);
                if (chargeIndex === -1) {
                    willRemoveCharges.push(addedLineCharges[i]);
                }
            }
        }

        //silinecek vergiler silindi.
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            for (let j = 0; j < willRemoveCharges.length; j++) {
                let index = trdDocInvoiceLines[i].trdDocInvoiceLineCharges.map(function (charge) {
                    return charge.taxCode.code;
                }).indexOf(willRemoveCharges[j].taxCode.code);
                if (index !== -1)
                    trdDocInvoiceLines[i].trdDocInvoiceLineCharges.splice(index, 1);
            }
        }

        //eklenecek ve yüzdesi güncellenecek vergi işlemleri.
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            for (let j = 0; j < newAddedLineCharges.length; j++) {
                let index = trdDocInvoiceLines[i].trdDocInvoiceLineCharges.map(function (charge) {
                    return charge.taxCode.code;
                }).indexOf(newAddedLineCharges[j].taxCode.code);
                if (index === -1) {
                    trdDocInvoiceLines[i].trdDocInvoiceLineCharges.push(newAddedLineCharges[j]);
                } else {
                    trdDocInvoiceLines[i].trdDocInvoiceLineCharges[index][(newAddedLineCharges[j].calculatedBy === "AMOUNT") ? "percentage" : "perUnitAmount"] =
                        newAddedLineCharges[j][(newAddedLineCharges[j].calculatedBy === "AMOUNT") ? "percentage" : "perUnitAmount"];
                    trdDocInvoiceLines[i].trdDocInvoiceLineCharges[index]["exemptionReason"] = newAddedLineCharges[j]["exemptionReason"];
                    trdDocInvoiceLines[i].trdDocInvoiceLineCharges[index]["exemptionReasonCode"] = newAddedLineCharges[j]["exemptionReasonCode"];
                    if (newAddedLineCharges[j].taxCode.code === "9015")
                        trdDocInvoiceLines[i].trdDocInvoiceLineCharges[index]["withholdingCode"] = newAddedLineCharges[j].withholdingCode;

                }
            }
            trdDocInvoiceLines[i].trdDocInvoiceLineCharges.sort((charge1, charge2) => charge1.taxCode.priority - charge2.taxCode.priority);
            trdDocInvoiceLines[i] = InvoiceLines.calculate(trdDocInvoiceLines[i], ((this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
        }
        this.setState({
            lineChargeModal: false,
            addedLineCharges: newAddedLineCharges,
            trdDocInvoiceLines: trdDocInvoiceLines,
            addedLineKdvExemption: addedLineKdvExemption,
        });
        this.props.listener(trdDocInvoiceLines);
    }

    setDeliveryDetail(deliveryDetail) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            let tDeliveryDetail = deepCopyObject(deliveryDetail);
            if (this.state.index !== i) {
                tDeliveryDetail.recordId = null;
                tDeliveryDetail.invoiceLineId = null;
            }
            trdDocInvoiceLines[i].trdDocInvoiceLineDeliveryDetail = tDeliveryDetail
        }
        this.setState({invoiceLineModal: false, trdDocInvoiceLines: trdDocInvoiceLines});
        this.props.listener(trdDocInvoiceLines);
    }

    setMgmDetail(mgmDetail) {
        let {trdDocInvoiceLines} = this.state;
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            let tDeliveryDetail = deepCopyObject(mgmDetail);
            if (this.state.index !== i) {
                tDeliveryDetail.recordId = null;
                tDeliveryDetail.invoiceLineId = null;
            }
            trdDocInvoiceLines[i].trdDocInvoiceLineDeliveryDetail = tDeliveryDetail
        }
        this.setState({invoiceLineModal: false, trdDocInvoiceLines: trdDocInvoiceLines});
        this.props.listener(trdDocInvoiceLines);
    }

    setInvoiceLine(invoiceLine, type) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        const chargesZero = invoiceLine.trdDocInvoiceLineCharges.filter((charges) => charges.taxCode.code === '0059')[0];
        if (chargesZero?.percentage === 0){

            const index = invoiceLine.trdDocInvoiceLineCharges.indexOf(chargesZero);
            let newCharge = {
                allowanceReason: chargesZero.allowanceReason,
                amount: chargesZero.amount,
                avansMahsubu: chargesZero.avansMahsubu,
                avansMahsubuAmount: chargesZero.avansMahsubuAmount,
                calculatedBy: chargesZero.calculatedBy,
                direction: chargesZero.direction,
                exemptionReason:'001-Diplomatik İstisna',
                exemptionReasonCode: '001',
                nakitTeminati: chargesZero.nakitTeminati,
                nakitTeminatiAmount: chargesZero.nakitTeminatiAmount,
                perUnitAmount: chargesZero.perUnitAmount,
                percentage: chargesZero.percentage,
                recordId: chargesZero.recordId,
                taxCode: chargesZero.taxCode,
                taxableAmount: chargesZero.taxableAmount,
                withholdingCode: chargesZero.withholdingCode
            }
            invoiceLine.trdDocInvoiceLineCharges[index] = newCharge;
        }
        trdDocInvoiceLines[this.state.index] = invoiceLine;
        if (type === "new") {
            this.setState({trdDocInvoiceLines: trdDocInvoiceLines}, () => this.addInvoiceLine(true));
        } else {
            this.setState({invoiceLineModal: false, trdDocInvoiceLines: trdDocInvoiceLines});
        }
        this.props.listener(trdDocInvoiceLines);
    }

    setKonaklama(invoiceLine, type) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        trdDocInvoiceLines = [invoiceLine];
        if (type === "new") {
            this.setState({trdDocInvoiceLines: trdDocInvoiceLines}, () => this.addInvoiceLine(true));
        } else {
            this.setState({invoiceLineModal: false, trdDocInvoiceLines: trdDocInvoiceLines});
        }
        this.setState({isKonaklama: true})
        this.props.listener(trdDocInvoiceLines);
    }

    removeInvoiceLine(index) {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        if (trdDocInvoiceLines.length === 1) {
            Swal({
                title: 'Uyarı ! ',
                text: ('Belge en az bir satır içermelidir.'),
                type: 'error',
                confirmButtonText: 'Tamam'
            });
        } else {
            trdDocInvoiceLines.splice(index, 1);
            this.props.listener(trdDocInvoiceLines);
            this.setState({trdDocInvoiceLines: trdDocInvoiceLines});
        }
    }

    getChargeWithCode(code) {
        let charge = this.props.charges.find(function (charge) {
            return charge.code === code;
        });
        return charge;
    }

    arrowRenderer(e) {
        let onMouseDown = e.onMouseDown;
        return React.createElement('span', {
            className: 'search',
            onMouseDown: onMouseDown
        });
    }


    switchRoundKDV(e) {
        let message = "";
        if (e.target.checked) {
            message = "KDV tutarı hesaplamasında yukarı yuvarlama <strong style='font-weight: 100'>aktif</strong> hale getirildi.";
        } else {
            message = "KDV tutarı hesaplamasında yukarı yuvarlama <strong style='font-weight: 100'>pasif</strong> hale getirildi.";
        }
        Alert.info(message, {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 1000
        });
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        for (let i = 0; i < trdDocInvoiceLines.length; i++) {
            trdDocInvoiceLines[i] = InvoiceLines.calculate(trdDocInvoiceLines[i], ((this.props.invoiceTypeCode === "SGK" && e.target.checked) ? Decimal.ROUND_UP : Decimal.ROUND_HALF_UP), this.state.fromTotalToUnit);
        }
        this.setState({isRoundKDV: e.target.checked, trdDocInvoiceLines: trdDocInvoiceLines});
    }

    switchFromTotalToUnit(e) {
        this.setState({fromTotalToUnit: e.target.checked});
    }

    applyMedikalIcmal(medulaData) {
        let result = isValidMedikalIcmal(medulaData);
        let valid = result.valid;
        if (valid) {
            let trdDocInvoiceLines = [];
            let chargeList = [];
            if (medulaData && medulaData.kdv0Amount && medulaData.kdv0AmountExcluded) {
                chargeList.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: new Decimal(medulaData.kdv0Amount - medulaData.kdv0AmountExcluded).toNumber(),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: medulaData.groupName + " (%0)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.kdv0AmountExcluded).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.kdv0AmountExcluded).toNumber(),
                    trdDocInvoiceLineCharges: chargeList,
                    trdDocInvoiceLineDeliveryDetail: null
                });
            }

            if (medulaData && medulaData.kdv8Amount && medulaData.kdv8AmountExcluded) {
                let chargeList2 = [];
                chargeList2.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: new Decimal(medulaData.kdv8Amount - medulaData.kdv8AmountExcluded).toNumber(),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: new Decimal(8).toNumber(),
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: medulaData.groupName + " (%8)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.kdv8AmountExcluded).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.kdv8AmountExcluded).toNumber(),
                    trdDocInvoiceLineCharges: chargeList2,
                    trdDocInvoiceLineDeliveryDetail: null
                });
            }

            if (medulaData && medulaData.kdv18Amount && medulaData.kdv18AmountExcluded) {
                let chargeList3 = [];
                chargeList3.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: new Decimal(medulaData.kdv18Amount - medulaData.kdv18AmountExcluded).toNumber(),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: new Decimal(18).toNumber(),
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: medulaData.groupName + (medulaData.groupName.includes("İşitme Cihazı") ? " Pili" : "") + " (%18)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.kdv18AmountExcluded).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.kdv18AmountExcluded).toNumber(),
                    trdDocInvoiceLineCharges: chargeList3,
                    trdDocInvoiceLineDeliveryDetail: null
                });
            }

            if (medulaData && medulaData.kdv10Amount && medulaData.kdv10AmountExcluded) {
                let chargeList4 = [];
                chargeList4.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: new Decimal(medulaData.kdv10Amount - medulaData.kdv10AmountExcluded).toNumber(),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: new Decimal(10).toNumber(),
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: medulaData.groupName + (medulaData.groupName.includes("İşitme Cihazı") ? " Pili" : "") + " (%10)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.kdv10AmountExcluded).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.kdv10AmountExcluded).toNumber(),
                    trdDocInvoiceLineCharges: chargeList4,
                    trdDocInvoiceLineDeliveryDetail: null
                });
            }

            if (medulaData && medulaData.kdv20Amount && medulaData.kdv20AmountExcluded) {
                let chargeList5 = [];
                chargeList5.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: new Decimal(medulaData.kdv20Amount - medulaData.kdv20AmountExcluded).toNumber(),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: new Decimal(20).toNumber(),
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: medulaData.groupName + (medulaData.groupName.includes("İşitme Cihazı") ? " Pili" : "") + " (%20)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.kdv20AmountExcluded).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.kdv20AmountExcluded).toNumber(),
                    trdDocInvoiceLineCharges: chargeList5,
                    trdDocInvoiceLineDeliveryDetail: null
                });
            }

            if (medulaData && medulaData.kdv0Amount == null && medulaData.kdv8Amount == null && medulaData.kdv18Amount == null && medulaData.kdv10Amount == null && medulaData.kdv20Amount == null) {
                let unitPrice = (new Decimal(medulaData.totalPayableAmount).mul(new Decimal(100)).div(new Decimal(100).add(new Decimal(medulaData.kdvPercentage))).toNumber());
                let chargeList = [];
                chargeList.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: (new Decimal(unitPrice).mul(new Decimal(medulaData.kdvPercentage)).div(new Decimal(100)).toNumber()),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: (new Decimal(medulaData.kdvPercentage).toNumber()),
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });

                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: medulaData.groupName,
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: unitPrice,
                    lineExtensionAmount: unitPrice,
                    trdDocInvoiceLineCharges: chargeList,
                    trdDocInvoiceLineDeliveryDetail: null
                });
                medulaData.type= "medikal";
            }

            this.props.listener(trdDocInvoiceLines, medulaData);
            this.setState({trdDocInvoiceLines, medulaModal: false});
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    applyMedulaOptik(medulaData) {
        let result = isValidMedulaOptikData(medulaData);
        let valid = result.valid;
        if (valid) {
            if (medulaData) {
                let trdDocInvoiceLines = [];
                let chargeList = [];
                chargeList.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: "Muaf Verilen (" + medulaData.recipeCount + " Adet)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.exemptGiven).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.exemptGiven).toNumber(),
                    trdDocInvoiceLineCharges: chargeList,
                    trdDocInvoiceLineDeliveryDetail: null
                });

                let chargeList2 = [];
                chargeList2.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: "%10 Katılımlı Verilen (" + medulaData.recipeCount + " Adet)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.percent10Given).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.percent10Given).toNumber(),
                    trdDocInvoiceLineCharges: chargeList2,
                    trdDocInvoiceLineDeliveryDetail: null
                });

                let chargeList3 = [];
                chargeList3.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: "%20 Katılımlı Verilen (" + medulaData.recipeCount + " Adet)",
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: new Decimal(medulaData.percent20Given).toNumber(),
                    lineExtensionAmount: new Decimal(medulaData.percent20Given).toNumber(),
                    trdDocInvoiceLineCharges: chargeList3,
                    trdDocInvoiceLineDeliveryDetail: null
                });

                let externalCustomer = {
                    commerceChamber: null,
                    customer: null,
                    externalCustomerAddressList: [],
                    familyName: null,
                    formattedName: "SOSYAL GÜVENLİK KURUMU BAŞKANLIĞI",
                    givenName: null,
                    mersisNumber: null,
                    middleName: null,
                    recordId: null,
                    taxOffice: "HİTİT VERGİ DAİRESİ MÜDÜRLÜĞÜ",
                    title: "SOSYAL GÜVENLİK KURUMU",
                    tradeRegistrationNumber: null,
                    vknTckn: "7750409379"
                };
                let externalCustomerAddress = {
                    buildingName: null,
                    buildingNo: null,
                    cityName: "Ankara",
                    citySubdivisionName: "Çankaya",
                    countryName: "TÜRKİYE",
                    email: null,
                    fax: null,
                    postalAddressRegion: null,
                    postalAddressRoom: null,
                    postalZone: "06520",
                    postboxAlias: "urn:mail:defaultpk@sgk.gov.tr",
                    recordId: null,
                    streetName: "Ziyabey Cad. Balgat",
                    telephone: null,
                    webSite: null
                };
                this.props.listener(trdDocInvoiceLines, medulaData, externalCustomer, externalCustomerAddress);
                this.setState({trdDocInvoiceLines, medulaModal: false});
            }
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    applyMedula(medulaData) {
        if(medulaData.type==="cyprusMedula")
            medulaData.type="medula";

        let result = isValidMedulaData(medulaData);
        let valid = result.valid;
        if (valid) {
            if (medulaData) {
                let unitPrice = (medulaData.type === "medula" ? new Decimal(medulaData.amount).sub(new Decimal(medulaData.remunerationAmount)).toNumber() : new Decimal(medulaData.amount).mul(new Decimal(100)).div(new Decimal(100).add(new Decimal(medulaData.kdvPercentage))).toNumber());
                let trdDocInvoiceLines = [];
                let chargeList = [];
                chargeList.push({
                    recordId: null,
                    amount: 0,
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: (medulaData.type === "medula" ? 0 : new Decimal(unitPrice).mul(new Decimal(medulaData.kdvPercentage)).div(new Decimal(100)).toNumber()),
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: 0,
                    percentage: (medulaData.type === "medula" ? 0 : new Decimal(medulaData.kdvPercentage).toNumber()),
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });

                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    manufacturersItemIdentification: null,
                    buyersItemIdentification: null,
                    itemId: null,
                    itemName: (medulaData.receiptCount + " Adet " + medulaData.groupName + " Reçete Bedeli"),
                    quantity: 1,
                    unit: 'MON',
                    unitPrice: unitPrice,
                    lineExtensionAmount: (medulaData.type === "medula" ? new Decimal(medulaData.amount).sub(new Decimal(medulaData.remunerationAmount)).toNumber() : unitPrice),
                    trdDocInvoiceLineCharges: chargeList,
                    trdDocInvoiceLineDeliveryDetail: null
                });


                if (medulaData.type !== "medikal" && !new Decimal(medulaData.remunerationAmount).isZero()) {
                    let chargeList2 = [];
                    chargeList2.push({
                        recordId: null,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        direction: -1,
                        exemptionReasonCode: null,
                        taxableAmount: 0.0,
                        percentage: 0.0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0000"),
                        invoiceLineId: null,
                        withholdingCode: null
                    }, {
                        recordId: null,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        direction: 1,
                        exemptionReasonCode: null,
                        taxableAmount: 0,
                        percentage: 0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0015"),
                        invoiceLineId: null,
                        withholdingCode: null
                    });
                    trdDocInvoiceLines.push({
                        recordId: null,
                        itemCode: null,
                        manufacturersItemIdentification: null,
                        buyersItemIdentification: null,
                        itemId: null,
                        itemName: "Eczane Hizmet Bedeli",
                        quantity: 1,
                        unit: 'MON',
                        unitPrice: new Decimal(medulaData.remunerationAmount).toNumber(),
                        lineExtensionAmount: new Decimal(medulaData.remunerationAmount).toNumber(),
                        trdDocInvoiceLineCharges: chargeList2,
                        trdDocInvoiceLineDeliveryDetail: null
                    });
                }
                this.props.listener(trdDocInvoiceLines, medulaData);
                if (medulaData.isGocIdaresi)
                    this.getExternalCustomerGocIdaresi(medulaData.isGocIdaresi);
                this.setState({trdDocInvoiceLines, medulaModal: false});
            }
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    applyMedikal(medulaData) {
        let result = isValidMedulaData(medulaData);
        let valid = result.valid;
        if (valid) {
            if (medulaData) {
                let trdDocInvoiceLines = [];
                if((medulaData.type === 'medikal' && medulaData.groupName && medulaData.groupName.includes("İşitme"))){
                    //İşitme cihazı pil
                    let kdv3= (new Decimal(medulaData.isitmePilBirimFiyat).mul(new Decimal(medulaData.isitmePilAdet)).mul(new Decimal(0.20))).toNumber();
                    let matrah=new Decimal(medulaData.isitmePilBirimFiyat).mul(new Decimal(medulaData.isitmePilAdet)).toNumber();
                    let chargeList = [];
                    chargeList.push({
                        recordId: null,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        direction: -1,
                        exemptionReasonCode: null,
                        taxableAmount: 0.0,
                        percentage: 0.0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0000"),
                        invoiceLineId: null,
                        withholdingCode: null
                    }, {
                        recordId: null,
                        amount:0,
                        calculatedBy: "AMOUNT",
                        direction: 1,
                        exemptionReasonCode:this.props.exemptions.filter(f => f.numberCode === "317")[0].numberCode,
                        taxableAmount: 0,
                        percentage:  0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0015"),
                        invoiceLineId: null,
                        withholdingCode: null
                    });

                    trdDocInvoiceLines.push({
                        recordId: null,
                        itemCode: null,
                        manufacturersItemIdentification: null,
                        buyersItemIdentification: null,
                        itemId: null,
                        itemName: medulaData.groupName + " Reçete Bedeli",
                        quantity: medulaData.receiptCount,
                        unit: 'C62',
                        unitPrice: new Decimal(medulaData.amount).sub((new Decimal(matrah)).add(new Decimal(kdv3))).div(medulaData.receiptCount).toNumber(),
                        lineExtensionAmount: new Decimal(medulaData.amount).sub((new Decimal(matrah)).add(new Decimal(kdv3))).toNumber(),
                        trdDocInvoiceLineCharges: chargeList,
                        trdDocInvoiceLineDeliveryDetail: null
                    });
                    if (medulaData.type === 'medikal' && medulaData.groupName2 && medulaData.groupName2.includes("Yupas")) {
                        if (medulaData.payableAmount2 !== null && medulaData.amount2 !== null && medulaData.receiptCount2 !== null && medulaData.contributionAmount2 !== null) {
                            trdDocInvoiceLines.push({
                                recordId: null,
                                itemCode: null,
                                manufacturersItemIdentification: null,
                                buyersItemIdentification: null,
                                itemId: null,
                                itemName: medulaData.groupName2 + " Reçete Bedeli",
                                quantity: medulaData.receiptCount2,
                                unit: 'C62',
                                unitPrice: new Decimal(medulaData.amount2).sub((new Decimal(matrah)).add(new Decimal(kdv3))).div(medulaData.receiptCount2).toNumber(),
                                lineExtensionAmount: new Decimal(medulaData.amount2).sub((new Decimal(matrah)).add(new Decimal(kdv3))).toNumber(),
                                trdDocInvoiceLineCharges: chargeList,
                                trdDocInvoiceLineDeliveryDetail: null
                            });
                        }
                    }

                    if(!(new Decimal(matrah).equals(new Decimal(0)))){
                        //İşitme cihazı pil
                        let chargeList2 = [];
                        chargeList2.push({
                            recordId: null,
                            amount: 0,
                            calculatedBy: "AMOUNT",
                            direction: -1,
                            exemptionReasonCode: null,
                            taxableAmount: 0.0,
                            percentage: 0.0,
                            perUnitAmount: 0.0,
                            taxCode: this.getChargeWithCode("0000"),
                            invoiceLineId: null,
                            withholdingCode: null
                        }, {
                            recordId: null,
                            amount:kdv3,
                            calculatedBy: "AMOUNT",
                            direction: 1,
                            exemptionReasonCode: null,
                            taxableAmount: matrah,
                            percentage:  20,
                            perUnitAmount: 0.0,
                            taxCode: this.getChargeWithCode("0015"),
                            invoiceLineId: null,
                            withholdingCode: null
                        });

                        trdDocInvoiceLines.push({
                            recordId: null,
                            itemCode: null,
                            manufacturersItemIdentification: null,
                            buyersItemIdentification: null,
                            itemId: null,
                            itemName: (medulaData.isitmePilAdet + " Adet İşitme Cihazı Pil Bedeli"),
                            quantity: new Decimal(medulaData.isitmePilAdet).toNumber(),
                            unit: 'C62',
                            unitPrice: new Decimal(medulaData.isitmePilBirimFiyat).toNumber(),
                            lineExtensionAmount: (new Decimal(matrah)).toNumber(),
                            trdDocInvoiceLineCharges: chargeList2,
                            trdDocInvoiceLineDeliveryDetail: null
                        });
                    }
                }else {
                    let kdv2, unitPrice2;
                    if (medulaData.payableAmount2 !== null && medulaData.amount2 !== null && medulaData.receiptCount2 !== null && medulaData.contributionAmount2 !== null) {
                        kdv2 = new Decimal(medulaData.payableAmount2).mul(new Decimal(medulaData.kdvPercentage)).div(new Decimal(100).add(new Decimal(medulaData.kdvPercentage))).toNumber();
                        unitPrice2 = new Decimal(medulaData.amount2).sub(kdv2).toNumber();
                    }
                    let unitPrice = (new Decimal(medulaData.amount).sub(medulaData.contributionAmount).mul(new Decimal(100)).div(new Decimal(100).add(new Decimal(medulaData.kdvPercentage))).toNumber());
                    let chargeList = [];
                    chargeList.push({
                        recordId: null,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        direction: -1,
                        exemptionReasonCode: null,
                        taxableAmount: 0.0,
                        percentage: 0.0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0000"),
                        invoiceLineId: null,
                        withholdingCode: null
                    }, {
                        recordId: null,
                        amount: (new Decimal(unitPrice).mul(new Decimal(medulaData.kdvPercentage)).div(new Decimal(100)).toNumber()),
                        calculatedBy: "AMOUNT",
                        direction: 1,
                        exemptionReasonCode: null,
                        taxableAmount: 0,
                        percentage: new Decimal(medulaData.kdvPercentage).toNumber(),
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0015"),
                        invoiceLineId: null,
                        withholdingCode: null
                    });

                    trdDocInvoiceLines.push({
                        recordId: null,
                        itemCode: null,
                        manufacturersItemIdentification: null,
                        buyersItemIdentification: null,
                        itemId: null,
                        itemName: (medulaData.receiptCount + " Adet " + medulaData.groupName + " Reçete Bedeli"),
                        quantity: 1,
                        unit: 'MON',
                        unitPrice: unitPrice,
                        lineExtensionAmount: unitPrice,
                        trdDocInvoiceLineCharges: chargeList,
                        trdDocInvoiceLineDeliveryDetail: null
                    });

                    if (medulaData.payableAmount2 !== null && medulaData.amount2 !== null && medulaData.receiptCount2 !== null && medulaData.contributionAmount2 !== null) {
                        let chargeList2 = [];
                        chargeList2.push({
                            recordId: null,
                            amount: 0,
                            calculatedBy: "AMOUNT",
                            direction: -1,
                            exemptionReasonCode: null,
                            taxableAmount: 0.0,
                            percentage: 0.0,
                            perUnitAmount: 0.0,
                            taxCode: this.getChargeWithCode("0000"),
                            invoiceLineId: null,
                            withholdingCode: null
                        }, {
                            recordId: null,
                            amount: kdv2,
                            calculatedBy: "AMOUNT",
                            direction: 1,
                            exemptionReasonCode: null,
                            taxableAmount: 0,
                            percentage: new Decimal(medulaData.kdvPercentage).toNumber(),
                            perUnitAmount: 0.0,
                            taxCode: this.getChargeWithCode("0015"),
                            invoiceLineId: null,
                            withholdingCode: null
                        });

                        trdDocInvoiceLines.push({
                            recordId: null,
                            itemCode: null,
                            manufacturersItemIdentification: null,
                            buyersItemIdentification: null,
                            itemId: null,
                            itemName: (medulaData.receiptCount2 + " Adet " + medulaData.groupName + " Reçete Bedeli"),
                            quantity: 1,
                            unit: 'MON',
                            unitPrice: unitPrice2,
                            lineExtensionAmount: unitPrice2,
                            trdDocInvoiceLineCharges: chargeList2,
                            trdDocInvoiceLineDeliveryDetail: null
                        });
                    }
                }
                this.props.listener(trdDocInvoiceLines, medulaData);
                this.setState({trdDocInvoiceLines, medulaModal: false});
            }
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    applyCezaevi(cezaeviData) {
        let result = isValidCezaeviData(cezaeviData);
        let valid = result.valid;
        if (valid) {
            if (cezaeviData) {
                let trdDocInvoiceLines = [];
                let chargeList = [];
                chargeList.push({
                    recordId: null,
                    //amount: new Decimal(cezaeviData.allowance + cezaeviData.publicAllowance + cezaeviData.share10And20Amount).toNumber(),
                    amount: new Decimal(cezaeviData.allowance).toNumber(),
                    calculatedBy: "AMOUNT",
                    direction: -1,
                    exemptionReasonCode: null,
                    taxableAmount: 0.0,
                    percentage: 0.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0000"),
                    invoiceLineId: null,
                    withholdingCode: null
                }, {
                    recordId: null,
                    amount: cezaeviData.kdv8Amount,
                    calculatedBy: "AMOUNT",
                    direction: 1,
                    exemptionReasonCode: null,
                    taxableAmount: cezaeviData.kdv8TaxableAmount,
                    percentage: 8.0,
                    perUnitAmount: 0.0,
                    taxCode: this.getChargeWithCode("0015"),
                    invoiceLineId: null,
                    withholdingCode: null
                });
                trdDocInvoiceLines.push({
                    recordId: null,
                    itemCode: null,
                    itemId: null,
                    itemName: cezaeviData.recipeCount + " ADET REÇETE PSF TOPLAMI",
                    quantity: 1,
                    unit: 'MON',
                    // unitPrice: new Decimal(cezaeviData.totalPrice - cezaeviData.kdv8Amount).toNumber(),
                    // lineExtensionAmount: new Decimal(cezaeviData.totalPrice - cezaeviData.kdv8Amount).toNumber(),
                    unitPrice: new Decimal(cezaeviData.totalPrice).add(cezaeviData.allowance).toNumber(),
                    lineExtensionAmount: new Decimal(cezaeviData.kdv8TaxableAmount ? cezaeviData.kdv8TaxableAmount : 0).toNumber(),
                    trdDocInvoiceLineCharges: chargeList,
                    trdDocInvoiceLineDeliveryDetail: null
                });

                if (cezaeviData.remuneration !== 0) {
                    let chargeList2 = [];
                    chargeList2.push({
                        recordId: null,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        direction: -1,
                        exemptionReasonCode: null,
                        taxableAmount: 0.0,
                        percentage: 0.0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0000"),
                        invoiceLineId: null,
                        withholdingCode: null
                    }, {
                        recordId: null,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        direction: 1,
                        exemptionReasonCode: null,
                        taxableAmount: 0,
                        percentage: 0.0,
                        perUnitAmount: 0.0,
                        taxCode: this.getChargeWithCode("0015"),
                        invoiceLineId: null,
                        withholdingCode: null
                    });
                    trdDocInvoiceLines.push({
                        recordId: null,
                        itemCode: null,
                        itemId: null,
                        itemName: "ECZANE HİZMET BEDELİ",
                        quantity: 1,
                        unit: 'MON',
                        unitPrice: new Decimal(cezaeviData.remuneration).toNumber(),
                        lineExtensionAmount: new Decimal(cezaeviData.remuneration).toNumber(),
                        trdDocInvoiceLineCharges: chargeList2,
                        trdDocInvoiceLineDeliveryDetail: null
                    });
                }

                this.props.listener(trdDocInvoiceLines, cezaeviData);
                this.setState({trdDocInvoiceLines, cezaeviModal: false});
            } else {
                Alert.error(result.errorMessage, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 8000
                });
            }
        }
    }

    getExternalCustomerGocIdaresi(isGocIdaresi) {
        let self = this;
        let params = {
            url: "/externalCustomerGocIdaresi/getExternalCustomerGocIdaresi",
            method: "get"
        };
        request(params)
            .then(response => {
                self.props.gocIdaresi(response.data, isGocIdaresi);
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    setTrdDocInvoiceLineDeliveryDetail(lineDeliveryDetail) {
        return this.props.profileId === "IHRACAT" ? {
            actualPackageId: lineDeliveryDetail ? lineDeliveryDetail.actualPackageId : "",
            actualPackagePTC: lineDeliveryDetail ? lineDeliveryDetail.actualPackagePTC : "1A",
            actualPackageQuantity: lineDeliveryDetail ? lineDeliveryDetail.actualPackageQuantity : "",
            buildingName: lineDeliveryDetail ? lineDeliveryDetail.buildingName : "",
            buildingNumber: lineDeliveryDetail ? lineDeliveryDetail.buildingNumber : "",
            city: lineDeliveryDetail ? lineDeliveryDetail.city : "",
            citySubdivion: lineDeliveryDetail ? lineDeliveryDetail.citySubdivion : "",
            country: lineDeliveryDetail ? lineDeliveryDetail.country : "",
            deliveryTerms: lineDeliveryDetail ? lineDeliveryDetail.deliveryTerms : "DAF",
            gtip: lineDeliveryDetail ? lineDeliveryDetail.gtip : "",
            packageBrand: lineDeliveryDetail ? lineDeliveryDetail.packageBrand : "",
            postalZone: lineDeliveryDetail ? lineDeliveryDetail.postalZone : "",
            recordId: lineDeliveryDetail ? lineDeliveryDetail.recordId : null,
            shipmentId: lineDeliveryDetail ? lineDeliveryDetail.shipmentId : "",
            streetName: lineDeliveryDetail ? lineDeliveryDetail.streetName : "",
            beyanEdilenKiymetDegeri: lineDeliveryDetail ? lineDeliveryDetail.beyanEdilenKiymetDegeri : "",
            transportMeansTypeCode: lineDeliveryDetail ? lineDeliveryDetail.transportMeansTypeCode : "",
            transportModeCode: lineDeliveryDetail ? lineDeliveryDetail.transportModeCode : "1",
            declaredForCarriageValueAmount: lineDeliveryDetail ? lineDeliveryDetail.declaredForCarriageValueAmount : "",
            insuranceValueAmount: lineDeliveryDetail ? lineDeliveryDetail.insuranceValueAmount : ""
        } : null
    }

    setTrdDocInvoiceLines() {
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        for(let item in trdDocInvoiceLines){
            trdDocInvoiceLines[item].trdDocInvoiceLineDeliveryDetail= this.setTrdDocInvoiceLineDeliveryDetail(trdDocInvoiceLines[item].trdDocInvoiceLineDeliveryDetail);
        }
        return trdDocInvoiceLines;
    }

    onInputChange(e, label, index){
        let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
        if(!!e.target.value){
            trdDocInvoiceLines[index][label] = e.target.value;
            if (label === "itemName") {
                for (let i = 0; i < trdDocInvoiceLines[index].trdDocInvoiceLineCharges.length; i++) {
                    trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount = trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount === "" ? new Decimal(0) : trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].amount;
                    trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage = trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage === "" ? new Decimal(0) : trdDocInvoiceLines[index].trdDocInvoiceLineCharges[i].percentage;
                }
                this.props.listener(trdDocInvoiceLines);
            }
            this.setState({trdDocInvoiceLines});
        }
    }

    onInputKeyDown(e, index) {
        if (e.keyCode === 9) {
            if (!!e.target.value) {
                let trdDocInvoiceLines = deepCopyObject(this.state.trdDocInvoiceLines);
                trdDocInvoiceLines[index]["itemName"] = e.target.value;
                this.props.listener(trdDocInvoiceLines);
                this.setState({trdDocInvoiceLines});
            }
            window.setTimeout(function () {
                const quantityInput = document.getElementById("quantity_" + index);
                quantityInput.focus();
                quantityInput.select();
            }, 0);
        }
    }

    render()
    {
        const { isMobile } = this.state;
        const kdvValues = [
            {value: "20", label: "20%"},
            {value: "18", label: "18%"},
            {value: "10", label: "10%"},
            {value: "8", label: "8%"},
            {value: "1", label: "1%"},
            {value: "0", label: "0%"}
        ];

        if (this.state.hasError) {
            return <h1>Bir Hata ile Karşılaşıldı.</h1>;
        } else {
            return (
                <div className="col-sm-12">
                    <div className="card-header" style={{padding: '1em 0 1em 0'}}>
                        <div className="row">
                            <div className="col-sm-3 row" style={{margin: '0 auto'}}>
                                <h4 className="card-title" style={{display: 'inline'}}>Ürün Hizmet Bilgileri</h4>
                                <img className="simple-text logo-mini fa-spin"
                                     src={process.env.REACT_APP_CONTEXT_NAME + "/image/refresh_blue.png"}
                                     style={{
                                         paddingTop: '0px',
                                         width: '19px',
                                         marginTop: '-4px',
                                         marginRight: '10px',
                                         marginLeft: '10px',
                                         display: (this.state.processingExcel ? '' : 'none')
                                     }}
                                />
                            </div>

                            {/*<div className="col-sm-3 " ></div>*/}
                            <div className="col-sm-9" style={{float: 'right'}}>
                                <div className="">
                                    <input ref={this.inputFile}
                                           type="file" accept=".xlsx,.xls" multiple={false}
                                           style={{
                                               display: 'block',
                                               visibility: 'hidden',
                                               width: '0px',
                                               height: '0px'
                                           }}
                                           onChange={this.handleUploadExcel}/>

                                    <div className="">
                                        {this.props.invoiceTypeCode !== 'SARJ' && this.props.invoiceTypeCode !== 'SARJANLIK' &&
                                        <button type="button"
                                                style={{
                                                    float: 'right', marginTop: '0px', padding: '10px 39px 10px 16px',
                                                    marginLeft: '18px', marginRight: '-15px'
                                                }}
                                                className="TekBtn ekle hizala pull-right  btn-default btn-md "
                                                onClick={(e) => this.addInvoiceLine(false)}>Satır Ekle
                                        </button>
                                        }
                                    </div>
                                    <div className="" style={{float: 'right'}}>
                                        <button type="button" className="TekBtn edit pull-right" style={{
                                            float: 'right',
                                            padding: '10px 44px 10px 19px',
                                            marginLeft: '7px',
                                            marginRight: '-15px',
                                            marginTop: '0px',
                                            background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))',
                                            fontSmooth: 'auto'
                                        }} onClick={this.editLineCharges}>Toplu Vergİ Düzenle
                                        </button>
                                    </div>
                                    <div className="" style={{float: 'right'}}>
                                        <button className="MenuBtn2 listt"
                                                style={{
                                                    float: 'right',
                                                    marginLeft: '7px',
                                                    padding: '10px 43px 9px 13px',
                                                    marginTop: '0px',
                                                }}
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                            Excel
                                        </button>

                                        <div className="dropdown-menu">
                                            <a className="dropdown-item"
                                               onClick={() => this.inputFile && this.inputFile.current && this.inputFile.current.click()}><i
                                                className="fa fa-file-excel-o"/> Excel'den Yükle</a>
                                            <a className="dropdown-item"
                                               onClick={this.exportToExcel}><i
                                                className="fas fa-external-link-alt"/> Excel'e
                                                Aktar</a>
                                            <a className="dropdown-item"
                                               onClick={this.exportToExcel}><i className="fa fa-download"/> Örnek
                                                Excel
                                                İndir</a>
                                        </div>
                                    </div>
                                    {this.state.showMedulaImport &&
                                    <div className="">
                                        <button type="button" className="TekBtn edit pull-right hizala"
                                                onClick={() => this.setState({medulaModal: true})}>Medula'dan Aktar
                                        </button>
                                    </div>
                                    }
                                    {this.state.showMedulaImport &&
                                    <div className="" style={{float: 'right'}}>
                                        <button type="button" className="TekBtn edit pull-right"
                                                style={{
                                                    float: 'right',
                                                    marginRight: '7px',
                                                    background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
                                                }}
                                                onClick={() => this.setState({cezaeviModal: true})}>Cezaevİ Fatura Aktar
                                        </button>
                                    </div>}
                                    <div className="" style={{float: 'right'}}>
                                        {(this.props.profileId === 'TICARIFATURA' || this.props.profileId === 'TEMELFATURA' || this.props.profileId === 'EARSIVFATURA') &&
                                            this.props.invoiceTypeCode === "SATIS" &&
                                            showKonaklamaVergisiButton(EntegratorConf.identifier) &&
                                            <button type="button" className="TekBtn edit pull-right"
                                                    style={{
                                                        float: 'right',
                                                        marginRight: '7px',
                                                        background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
                                                    }}
                                                    onClick={() => this.setState({konaklamaModal: true})}>Konaklama
                                                Vergİsİ
                                            </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body" style={{padding: '1em 0 1em 0'}}>
                        <div className="row invoiceLines">
                            <div className="col-sm-12" style={{padding: '0'}}>
                                <table className="" style={{textAlign: 'center'}}>
                                    <thead>
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="2%">#</th>
                                        {this.props.showOrderManagerLineNum &&
                                        <th width="5%">Satır Numarası</th>
                                        }
                                        {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                            <th width="12%">Ürün Kodu</th>
                                        }
                                        <th width="12%" id={"itemName"}>Ürün / Hizmet <i
                                            className="fa fa-question-circle"
                                            style={{float: 'right'}} aria-hidden="true"/>
                                            <UncontrolledTooltip placement="right" target={"itemName"}
                                                                 delay={0}>Yazılan ürünü stoğa kaydetmek istemiyorsanız
                                                TAB tuşuna veya Fare ile boş bir alana
                                                tıklayabilirsiniz. </UncontrolledTooltip></th>
                                        <th width="7%">Miktar</th>
                                        <th width="7%">Birim</th>
                                        {VirtualHost.conf.resourcePrefix === "eczacikart" && this.props.profileId === 'EARSIVFATURA' &&
                                            <th width="7%">Toplam Fiyat
                                                <input type="checkbox"
                                                       checked={this.state.fromTotalToUnit}
                                                       style={{float: 'right'}} data-toggle="toggle"
                                                       title="Toplam fiyattan birim fiyat hesapla"
                                                       onChange={this.switchFromTotalToUnit}/></th>
                                        }
                                        <th width="7%">Birim Fiyat</th>
                                        {this.props.currentUser.showVatProccessing &&
                                            <th width="7%">KDV Hariç</th>
                                        }
                                        {this.props.currentUser.showVatProccessing &&
                                            <th width="7%">KDV Dahil</th>
                                        }
                                        {(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") &&
                                            <th width="10%">Gümrük <br/>Takip No</th>
                                        }
                                        {(this.props.invoiceTypeCode === "SARJANLIK") &&
                                            <th width="10%">Sarj Ünitesi <br/>Seri No</th>
                                        }
                                        <th width="5%">İskonto(%)</th>
                                        <th width="5%">İskonto {this.props.suffix ? '(' + this.props.suffix + ')' : 'Tutarı'}</th>
                                        {this.props.invoiceTypeCode !== 'TEVKIFATIADE' &&
                                            <th width="5%">KDV(%)</th>
                                        }
                                        {this.props.invoiceTypeCode !== 'TEVKIFATIADE' &&
                                            <th width="5%">KDV {this.props.suffix ? '(' + this.props.suffix + ')' : 'Tutarı'}
                                                {this.props.invoiceTypeCode === "SGK" &&
                                                    <input type="checkbox"
                                                           checked={this.state.isRoundKDV}
                                                           style={{float: 'right'}}
                                                           onChange={this.switchRoundKDV}/>
                                                }
                                            </th>
                                        }
                                        {(VirtualHost.conf.resourcePrefix !== "eczacikart" || (VirtualHost.conf.resourcePrefix === "eczacikart" && this.props.profileId !== 'EARSIVFATURA')) &&
                                            <th width="7%">{this.props.invoiceTypeCode !== 'TEVKIFATIADE' ? "Toplam Fiyat" : "İadeye Konu İşlem Bedeli"}
                                                {this.props.invoiceTypeCode !== 'TEVKIFATIADE' &&
                                                    <input type="checkbox"
                                                           checked={this.state.fromTotalToUnit}
                                                           style={{float: 'right'}} data-toggle="toggle"
                                                           title="Toplam fiyattan birim fiyat hesapla"
                                                           onChange={this.switchFromTotalToUnit}/>}
                                            </th>
                                        }
                                        {(this.props.profileId === "HKS" || this.props.invoiceTypeCode === "HKSSATIS" || this.props.invoiceTypeCode === "HKSKOMISYONCU") &&
                                            <th width="5%">Künye Numarası</th>}
                                        {this.props.invoiceTypeCode === 'TEVKIFATIADE' &&
                                            <th width="5%">İade Edilen Mal Oranı (%)</th>
                                        }
                                        {this.props.invoiceTypeCode === 'TEVKIFATIADE' &&
                                            <th width="5%">Alıştaki Tevkifatsız KDV Tutarı</th>
                                        }
                                        {this.props.invoiceTypeCode === 'TEVKIFATIADE' &&
                                            <th width="5%">İadeye Konu KDV Tutarı</th>
                                        }
                                        <th width="3%">İşlemler</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.trdDocInvoiceLines.map((trdDocInvoiceLine, index) =>
                                            <tr key={index}>
                                                <td data-label={"#"}>{index + 1}</td>
                                                {this.props.showOrderManagerLineNum &&
                                                <td data-label={"Satır Numarası"} className={"form-group" + this.validateClass('lineNumber_' + index)}>
                                                    <input id={'lineNumber_' + index}
                                                           type="text"
                                                           data-vlength="0,255"
                                                           className="form-control"
                                                           onBlur={this.validateField}
                                                           value={trdDocInvoiceLine.lineNumber}
                                                           placeholder="Satır No giriniz"
                                                           onChange={(e) => this.onChange({
                                                               value: e.target.value,
                                                               name: "lineNumber"
                                                           }, index)}/>
                                                    {this.validateMessage('lineNumber_' + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={'lineNumber_' + index}
                                                                         delay={0}>
                                                        {this.validateMessage('lineNumber_' + index)}
                                                    </UncontrolledTooltip>}
                                                </td>
                                                }
                                                {VirtualHost.conf.resourcePrefix === "eczacikart" &&
                                                <td data-label={"Ürün Kodu"} className={"form-group" + this.validateClass('itemCode_' + index)}>
                                                    <Select.AsyncCreatable
                                                        multi={false}
                                                        ignoreAccents={false}
                                                        id={'itemCode' + index}
                                                        value={{
                                                            value: trdDocInvoiceLine.itemCode,
                                                            label: trdDocInvoiceLine.itemCode
                                                        }}
                                                        onChange={(e) => e && this.onStockChange(e, index)}
                                                        isLoading={true}
                                                        autoload={false}
                                                        cache={false}
                                                        clearable={false}
                                                        noResultsText="Kayıt bulunamadı."
                                                        searchPromptText="Arama için en az 3 karakter giriniz."
                                                        placeholder="Ürün Kodu ile arama yapabilirsiniz"
                                                        loadingPlaceholder="Yükleniyor..."
                                                        filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
                                                        onNewOptionClick={(option) => this.createStock(option, index, "itemCode")}
                                                        promptTextCreator={(label) => "Stoğa Ekle"}
                                                        showNewOptionAtTop={false}
                                                        arrowRenderer={this.arrowRenderer}
                                                        onCloseResetsInput={false}
                                                        loadOptions={(key) => getStocks(key, "itemCode")}
                                                    />
                                                    {this.validateMessage('itemCode_' + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={'itemCode_' + index}
                                                                         delay={0}>
                                                        {this.validateMessage('itemCode_' + index)}
                                                    </UncontrolledTooltip>}
                                                </td>
                                                }
                                                <td data-label={"Ürün / Hizmet"} className={"form-group" + this.validateClass('itemName_' + index)}>
                                                    <Select.AsyncCreatable
                                                        multi={false}
                                                        ignoreAccents={false}
                                                        id={'itemName_' + index}
                                                        value={{
                                                            value: trdDocInvoiceLine.itemName,
                                                            label: trdDocInvoiceLine.itemName
                                                        }}
                                                        onChange={(e) => e && this.onStockChange(e, index)}
                                                        isLoading={true}
                                                        autoload={false}
                                                        cache={false}
                                                        clearable={false}
                                                        noResultsText="Kayıt bulunamadı."
                                                        searchPromptText="Arama için en az 1 karakter giriniz."
                                                        placeholder="Ürün Adı ile arama yapabilirsiniz"
                                                        loadingPlaceholder="Yükleniyor..."
                                                        filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
                                                        onNewOptionClick={(option) => this.createStock(option, index, "itemName")}
                                                        promptTextCreator={(label) => "Stoğa Ekle"}
                                                        showNewOptionAtTop={false}
                                                        arrowRenderer={this.arrowRenderer}
                                                        onBlurResetsInput={false}
                                                        onCloseResetsInput={false}
                                                        loadOptions={(key) => getStocks(key, "itemName")}
                                                        onBlur={(e)=> this.onInputChange(e, 'itemName', index)}
                                                        onInputKeyDown={(e) => this.onInputKeyDown(e, index)}
                                                    />
                                                    {this.validateMessage('itemName_' + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={'itemName_' + index}
                                                                         delay={0}>
                                                        {this.validateMessage('itemName_' + index)}
                                                    </UncontrolledTooltip>}
                                                </td>
                                                <td data-label={"Miktar"}>
                                                    <NumberFormat id={'quantity_' + index}
                                                                  value={trdDocInvoiceLine.quantity}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Miktar giriniz"
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "quantity"
                                                                  }, index)}
                                                                  className="form-control"/>
                                                </td>
                                                <td data-label={"Birim"}>
                                                    <Select
                                                        id={'unit_' + index}
                                                        placeholder="Birim Seçiniz"
                                                        value={trdDocInvoiceLine.unit}
                                                        clearable={false}
                                                        style={{width: "100%"}}
                                                        noResultsText="Sonuç yok"
                                                        onChange={(e) => e && this.onChange({
                                                            value: e.value,
                                                            name: "unit"
                                                        }, index)}
                                                        options={this.props.unitCodes.map(unitCode => ({
                                                            value: unitCode.shortCode,
                                                            label: unitCode.longCode
                                                        }))}
                                                    />
                                                </td>
                                                {VirtualHost.conf.resourcePrefix === "eczacikart" && this.props.profileId === 'EARSIVFATURA' &&
                                                <td data-label={"Toplam Fiyat"}>
                                                    <NumberFormat id={'totalPrice_' + index}
                                                                  value={(trdDocInvoiceLine.totalPrice)}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Toplam Fiyat giriniz"
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "totalPrice"
                                                                  }, index)}
                                                                  className="form-control"/>
                                                </td>}
                                                <td data-label={"Birim Fiyat"}>
                                                    <NumberFormat id={'unitPrice_' + index}
                                                                  value={trdDocInvoiceLine.unitPrice}
                                                                  allowNegative={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Birim Fiyat giriniz"
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "unitPrice"
                                                                  }, index)}
                                                                  className="form-control"/>
                                                </td>
                                                {this.props.currentUser.showVatProccessing &&
                                                    <td data-label={"KDV Hariç"}>
                                                        <NumberFormat id={'excludingVat_' + index}
                                                                      value={trdDocInvoiceLine.unitPrice}
                                                                      allowNegative={false}
                                                                      isNumericString={true}
                                                                      allowEmptyFormatting={false}
                                                                      decimalScale={9}
                                                                      thousandSeparator={'.'}
                                                                      decimalSeparator={','}
                                                                      displayType="input"
                                                                      placeholder="KDV Hariç Tutar giriniz"
                                                                      renderText={value => {
                                                                          value.replace(/\./g, ',')
                                                                      }}
                                                                      onValueChange={(e) => this.onChange({
                                                                          value: e.value,
                                                                          name: "unitPrice"
                                                                      }, index)}
                                                                      className="form-control"/>
                                                    </td>
                                                }

                                                {this.props.currentUser.showVatProccessing &&
                                                    <td data-label={"KDV Dahil"}>
                                                        <NumberFormat id={'includingVat_' + index}
                                                                      value={/*trdDocInvoiceLine.unitPrice + (trdDocInvoiceLine.unitPrice * (charge.percentage / 100))*/ trdDocInvoiceLine.includingVat}
                                                                      allowNegative={false}
                                                                      isNumericString={true}
                                                                      allowEmptyFormatting={false}
                                                                      decimalScale={9}
                                                                      thousandSeparator={'.'}
                                                                      decimalSeparator={','}
                                                                      displayType="input"
                                                                      placeholder="KDV Dahil Tutar giriniz"
                                                                      renderText={value => {
                                                                          value.replace(/\./g, ',')
                                                                          }}
                                                                          onValueChange={(e) => this.onChange({
                                                                              value: e.value,
                                                                              name: "includingVat"
                                                                          }, index)}
                                                                          className="form-control"/>
                                                        </td>
                                                }
                                                {(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") &&
                                                <td data-label={"Gümrük Takip No"} className={"form-group" + this.validateClass('gumrukTakipNo_' + index)}>
                                                    <input id={'gumrukTakipNo_' + index}
                                                           type="text"
                                                           data-vlength="0,255"
                                                           className="form-control"
                                                           onBlur={this.validateField}
                                                           value={trdDocInvoiceLine.gumrukTakipNo}
                                                           placeholder="Gümrük Takip No giriniz"
                                                           onChange={(e) => this.onChange({
                                                               value: e.target.value,
                                                               name: "gumrukTakipNo"
                                                           }, index)}/>
                                                    {this.validateMessage('gumrukTakipNo_' + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={'gumrukTakipNo_' + index}
                                                                         delay={0}>
                                                        {this.validateMessage('gumrukTakipNo_' + index)}
                                                    </UncontrolledTooltip>}
                                                </td>
                                                }
                                                {(this.props.invoiceTypeCode === "SARJANLIK") &&
                                                    <td data-label={"Şarj Ünitesi Seri No"} className={"form-group" + this.validateClass('chargeUnitSerialNumber_' + index)}>
                                                        <input id={'chargeUnitSerialNumber_' + index}
                                                               type="text"
                                                               data-vlength="0,255"
                                                               className="form-control"
                                                               onBlur={this.validateField}
                                                               value={trdDocInvoiceLine.chargeUnitSerialNumber}
                                                               placeholder="Şarj Ünitesi Seri No giriniz"
                                                               onChange={(e) => this.onChange({
                                                                   value: e.target.value,
                                                                   name: "chargeUnitSerialNumber"
                                                               }, index)}/>
                                                        {this.validateMessage('chargeUnitSerialNumber' + index) !== "" &&
                                                            <UncontrolledTooltip placement="right"
                                                                                 target={'chargeUnitSerialNumber_' + index}
                                                                                 delay={0}>
                                                                {this.validateMessage('chargeUnitSerialNumber_' + index)}
                                                            </UncontrolledTooltip>}
                                                    </td>
                                                }
                                                {
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0000")
                                                    }).map((charge, j) =>
                                                        <td data-label={"İskonto(%)"} key={j}>
                                                            <div style={{}}>
                                                                <NumberFormat
                                                                    id={charge.taxCode.code + '_percentage_' + j + '_' + index}
                                                                    value={(charge.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
                                                                    allowNegative={false}
                                                                    suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
                                                                    isNumericString={true}
                                                                    disabled={(!(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA" || this.props.invoiceTypeCode==="KONAKLAMAVERGISI") && charge.exemptionReasonCode) ? true : false}
                                                                    decimalScale={2}
                                                                    thousandSeparator={'.'}
                                                                    decimalSeparator={','}
                                                                    displayType="input"
                                                                    placeholder="İskonto(%) giriniz"
                                                                    renderText={value => {
                                                                        value.replace(/\./g, ',')
                                                                    }}
                                                                    onValueChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index, (charge.calculatedBy === "AMOUNT" ? "percentage" : "perUnitAmount"))}
                                                                    // className="form-control text2"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                                {
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0000")
                                                    }).map((charge, j) =>
                                                        <td data-label={`İskonto${this.props.suffix ? '(' + this.props.suffix + ')' : 'Tutarı'}`} key={j}>
                                                            <div style={{}}>
                                                                <NumberFormat
                                                                    id={charge.taxCode.code + '_amount_' + j + '_' + index}
                                                                    value={charge.amount}
                                                                    allowNegative={false}
                                                                    isNumericString={true}
                                                                    disabled={(!(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") && charge.exemptionReasonCode) ? true : false}
                                                                    suffix={this.props.suffix}
                                                                    decimalScale={2}
                                                                    thousandSeparator={'.'}
                                                                    decimalSeparator={','}
                                                                    displayType="input"
                                                                    placeholder="İskonto giriniz"
                                                                    renderText={value => {
                                                                        value.replace(/\./g, ',')
                                                                    }}
                                                                    onValueChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index, "amount")}
                                                                    // className="form-control text"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                                {this.props.invoiceTypeCode !== 'TEVKIFATIADE' &&
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0015")
                                                    }).map((charge, j) =>
                                                        <td data-label={"KDV(%)"} key={j}>
                                                            <div style={{}}>
                                                                {(this.state.fromTotalToUnit === undefined || this.state.fromTotalToUnit) ?
                                                                <NumberFormat
                                                                    id={charge.taxCode.code + '_percentage_' + j + '_' + index}
                                                                    value={(charge.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
                                                                    allowNegative={false}
                                                                    suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
                                                                    isNumericString={true}
                                                                    disabled={(!(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") && (charge.exemptionReasonCode && this.props.invoiceTypeCode !== "IHRACKAYITLI")) ? true : (this.props.invoiceTypeCode === 'KONAKLAMAVERGISI' ? true : false)}
                                                                    decimalScale={2}
                                                                    thousandSeparator={'.'}
                                                                    decimalSeparator={','}
                                                                    displayType="input"
                                                                    placeholder="KDV(%) giriniz"
                                                                    renderText={value => {
                                                                    value.replace(/\./g, ',')
                                                                }}
                                                                    onValueChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index, (charge.calculatedBy === "AMOUNT" ? "percentage" : "perUnitAmount"))}
                                                                    // className="form-control text2"
                                                                    className="form-control"
                                                                    />
                                                                    :
                                                                    <Select
                                                                        id={charge.taxCode.code + '_percentage_' + j + '_' + index}
                                                                        placeholder="KDV(%)"
                                                                        value={charge.percentage}
                                                                        disabled={this.props.invoiceTypeCode === 'KONAKLAMAVERGISI' ? true : false}
                                                                        renderText={value => {
                                                                            value.replace(/\./g, ',')
                                                                        }}
                                                                        clearable={false}
                                                                        style={{width: "100%"}}
                                                                        noResultsText="Sonuç yok"
                                                                        onChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index,  "percentage")}
                                                                        options={kdvValues}
                                                                    />
                                                                }
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                                {this.props.invoiceTypeCode !== 'TEVKIFATIADE' &&
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0015")
                                                    }).map((charge, j) =>
                                                        <td data-label={`KDV${this.props.suffix ? '(' + this.props.suffix + ')' : 'Tutarı'}`} key={j}>
                                                            <div style={{}}>
                                                                <NumberFormat
                                                                    id={charge.taxCode.code + '_amount_' + j + '_' + index}
                                                                    value={charge.amount}
                                                                    allowNegative={false}
                                                                    isNumericString={true}
                                                                    disabled={(!(this.props.profileId === "IHRACAT" || this.props.profileId === "YOLCUBERABERFATURA") && charge.exemptionReasonCode) ? true : (trdDocInvoiceLine.trdDocInvoiceLineDeliveryDetail === "konaklama" || this.props.invoiceTypeCode === 'KONAKLAMAVERGISI' ? true : false)}
                                                                    suffix={this.props.suffix}
                                                                    decimalScale={2}
                                                                    thousandSeparator={'.'}
                                                                    decimalSeparator={','}
                                                                    displayType="input"
                                                                    placeholder="KDV giriniz"
                                                                    renderText={value => {
                                                                        value.replace(/\./g, ',')
                                                                    }}
                                                                    onValueChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index, "amount")}
                                                                    // className="form-control text"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                                {(VirtualHost.conf.resourcePrefix !== "eczacikart" || (VirtualHost.conf.resourcePrefix === "eczacikart" && this.props.profileId !== 'EARSIVFATURA')) &&
                                                <td data-label={"Toplam Fiyat"}>
                                                    {isMobile &&
                                                        <div style={{display:'inline-flex',alignItems:'center'}}>
                                                            <small
                                                                className="mr-1 text-info"
                                                                style={{fontSize:'9px'}}
                                                            >T.Fiyattan Birim Fiyat Hesapla
                                                            </small>
                                                            <input type="checkbox"
                                                                   checked={this.state.fromTotalToUnit}
                                                                   style={{float: 'right'}} data-toggle="toggle"
                                                                   title="Toplam fiyattan birim fiyat hesapla"
                                                                   onChange={this.switchFromTotalToUnit}/>
                                                        </div>
                                                    }
                                                    <NumberFormat id={'totalPrice_' + index}
                                                                  value={(this.props.invoiceTypeCode === 'TEVKIFATIADE' ? trdDocInvoiceLine.lineExtensionAmount : trdDocInvoiceLine.totalPrice)}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={9}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  allowNegative={false}
                                                                  placeholder={this.props.invoiceTypeCode === 'TEVKIFATIADE' ? "İade Konu İşlem Bedeli giriniz" : "Toplam Fiyat giriniz"}
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: (this.props.invoiceTypeCode === 'TEVKIFATIADE' ? "lineExtensionAmount" : "totalPrice")
                                                                  }, index)}
                                                                  className="form-control"/>
                                                </td>}
                                                {(this.props.profileId === "HKS" || this.props.invoiceTypeCode === "HKSSATIS" || this.props.invoiceTypeCode === "HKSKOMISYONCU") &&
                                                <td data-label={"Künye Numarası"}>
                                                    <input id={'kunyeNo_' + index}
                                                           type="text"
                                                           className="form-control"
                                                           maxLength={19}
                                                           onBlur={this.validateField}
                                                           value={trdDocInvoiceLine.kunyeNo}
                                                           placeholder="Künye Numarası"
                                                           onChange={(e) => this.onChange({
                                                               value: e.target.value,
                                                               name: "kunyeNo"
                                                           }, index)}/>
                                                </td>}
                                                {this.props.invoiceTypeCode === 'TEVKIFATIADE' &&
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0015")
                                                    }).map((charge, j) =>
                                                        <td data-label={"İade Edilen Mal Oranı (%)"}>
                                                            <NumberFormat id={'rateOfReturnedGood_' + index}
                                                                          isNumericString={true}
                                                                          className="form-control"
                                                                          value={charge.rateOfReturnedGood}
                                                                          decimalScale={2}
                                                                          thousandSeparator={'.'}
                                                                          allowNegative={false}
                                                                          decimalSeparator={','}
                                                                          displayType="input"
                                                                          placeholder="İade Edilen Mal Oranı"
                                                                          onValueChange={(e) => this.onChangeTevkifatIade({
                                                                              value: e.value,
                                                                              name: "rateOfReturnedGood"
                                                                          }, index, charge.taxCode.code)}
                                                            />
                                                        </td>
                                                    )
                                                }
                                                {this.props.invoiceTypeCode === 'TEVKIFATIADE' &&
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0015")
                                                    }).map((charge, j) =>
                                                        <td data-label={"Alıştaki Tevkifatsız KDV Tutarı"}>
                                                            <NumberFormat id={'tevkifatsizKdvTutari_' + index}
                                                                          value={charge.tevkifatsizKdvTutari}
                                                                          allowNegative={false}
                                                                          className="form-control"
                                                                          decimalScale={9}
                                                                          thousandSeparator="."
                                                                          decimalSeparator=","
                                                                          displayType="input"
                                                                          placeholder="Alıştaki Tevkifatsız KDV Tutarı"
                                                                          renderText={values => {
                                                                              values.replace(/\./g, ",")
                                                                          }}
                                                                          onValueChange={(e) => this.onChangeTevkifatIade({
                                                                              value: e.value,
                                                                              name: "tevkifatsizKdvTutari"
                                                                          }, index, charge.taxCode.code)}
                                                            />
                                                        </td>
                                                    )
                                                }
                                                {this.props.invoiceTypeCode === 'TEVKIFATIADE' &&
                                                    trdDocInvoiceLine.trdDocInvoiceLineCharges.filter((tCharge) => {
                                                        return (tCharge.taxCode.code === "0015")
                                                    }).map((charge, j) =>
                                                        <td data-label={"İadeye Konu KDV Tutarı"}>
                                                            <NumberFormat id={'vatRefundAmount_' + index}
                                                                          isNumericString={true}
                                                                          className="form-control"
                                                                          allowNegative={false}
                                                                          disabled={true}
                                                                          value={charge.vatRefundAmount}
                                                                          decimalScale={9}
                                                                          thousandSeparator={'.'}
                                                                          decimalSeparator={','}
                                                                          displayType="input"
                                                                          placeholder="İadeye Konu KDV Tutarı"
                                                                          renderText={values => {
                                                                              values.replace(/\./g, ",")
                                                                          }}
                                                                          onValueChange={(e) => this.onChangeTevkifatIade({
                                                                              value: e.value,
                                                                              name: "vatRefundAmount"
                                                                          }, index, charge.taxCode.code)}
                                                            />
                                                        </td>
                                                    )
                                                }
                                                {!this.state.fromTotalToUnit &&
                                                <td data-label={"İşlemler"}>
                                                    <button type="button"
                                                            className={"Btn edit " + " btn-primary"}
                                                            style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                                            onClick={() => this.editInvoiceLine(index)}
                                                    >
                                                    </button>
                                                    {(this.props.profileId === 'ILAC_TIBBICIHAZ' || this.props.invoiceTypeCode === 'TEKNOLOJIDESTEK') &&
                                                        <button type="button"
                                                                onClick={() => this.addItsUtsInformationLine(index)}
                                                                data-toggle="tooltip" data-placement="bottom"
                                                                title="İTS/ÜTS Bilgisi Ekle"
                                                                style={{background: '#cdcf4e'}}
                                                                rel="tooltip" className="Btn btn-sm btn-icon">
                                                            <i className="fas fa-bars"></i>
                                                        </button>
                                                    }
                                                    {this.state.trdDocInvoiceLines.length > 1 &&
                                                    <button type="button" className="Btn temizle"
                                                            style={{margin: "0", background: '#FFCCCC'}}
                                                            onClick={() => this.removeInvoiceLine(index)}>

                                                    </button>
                                                    }
                                                </td>}
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {this.state.invoiceLineModal &&
                        <InvoiceLineModal
                            listenerDeliveryDetail={this.setDeliveryDetail}
                            listenerMgmDetail={this.setMgmDetail}
                            isKamu={this.props.isKamu}
                            isRoundKDV={(this.props.invoiceTypeCode === "SGK" && this.state.isRoundKDV)}
                            listener={this.setInvoiceLine}
                            modal={this.state.invoiceLineModal}
                            index={this.state.index}
                            invoiceLine={this.state.trdDocInvoiceLines[this.state.index]}
                            profileId={this.props.profileId}
                            invoiceTypeCode={this.props.invoiceTypeCode}
                            suffix={this.props.suffix}
                            charges={this.props.charges}
                            exemptions={this.props.exemptions}
                            unitCodes={this.state.unitCodes}
                            countries={this.state.countries}
                            withholdingTypes={this.state.withholdingTypes}
                            packageTypeCodes={this.state.packageTypeCodes}
                            deliveryTermsCodes={this.state.deliveryTermsCodes}
                            transportMeansTypeCodes={this.state.transportMeansTypeCodes}
                            transportModeCodes={this.state.transportModeCodes}
                            classificationTypes={this.props.classificationTypes}
                            fromTotalToUnit={this.state.fromTotalToUnit}
                            vknTckn={this.props.vknTckn}
                            currentUser={this.props.currentUser}
                        />
                        }
                        {this.state.invoiceLineItsUtsModal &&
                            <InvoiceLineItsUtsModal
                                modal={this.state.invoiceLineItsUtsModal}
                                closeModal={this.closeInvoiceLineItsUtsModal}
                                listener={this.setInvoiceLineItsUts}
                                index={this.state.index}
                                trdDocInvoiceLines={this.state.trdDocInvoiceLines}
                                profileId={this.props.profileId}
                                invoiceTypeCode={this.props.invoiceTypeCode}
                            />
                        }
                        {this.state.lineChargeModal &&
                        <LineChargeModal listener={this.setLineCharges}
                                         modal={this.state.lineChargeModal}
                                         addedLineCharges={this.state.addedLineCharges}
                                         charges={this.props.charges}
                                         withholdingTypes={this.state.withholdingTypes}
                                         invoiceTypeCode={this.props.invoiceTypeCode}
                                         suffix={this.props.suffix}
                                         exemptions={this.props.exemptions}
                                         profileId={this.props.profileId}
                                         addedLineKdvExemption={this.state.addedLineKdvExemption}
                                         addedLineOtvExemption={this.state.addedLineOtvExemption}

                        />

                        }
                        {this.state.stockModal &&
                        <StockModal listener={this.setStocks}
                                    modal={this.state.stockModal}
                                    exemptions={this.props.exemptions}
                                    stock={this.state.stock}
                                    isCreate={this.state.isCreate}
                                    currencyCodes={this.props.currencyCodes}
                                    unitCodes={this.props.unitCodes}
                                    isGtipRequired={(this.props.profileId === "IHRACAT")}
                                    withholdingTypes={this.state.withholdingTypes}
                                    type="invoice"
                                    isTevkifat={(this.props.invoiceTypeCode === "TEVKIFAT")}

                        />
                        }
                        {this.state.medulaModal &&
                        <MedulaModal applyMedula={this.applyMedula}
                                     applyMedulaOptik={this.applyMedulaOptik}
                                     applyMedikalIcmal={this.applyMedikalIcmal}
                                     applyMedikal={this.applyMedikal}
                                     toggleModal={() => this.setState({medulaModal: false})}
                                     medulaModal={this.state.medulaModal}
                                     currentUser={this.props.currentUser}
                        />
                        }
                        {this.state.cezaeviModal &&
                        <CezaeviModal applyCezaevi={this.applyCezaevi}
                                      toggleModal={() => this.setState({cezaeviModal: false})}
                                      cezaeviModal={this.state.cezaeviModal}
                        />
                        }
                        {this.state.konaklamaModal &&
                            <KonaklamaModal
                                toggleModal={() => this.setState({konaklamaModal: false})}
                                konaklamaModal={this.state.konaklamaModal}
                                unitCodes={this.state.unitCodes}
                                invoiceLine={this.state.trdDocInvoiceLines[this.state.index]}
                                listener={this.setKonaklama}
                            />
                        }
                    </div>
                </div>
            );
        }
    }
}

export default InvoiceLines;

